import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
let url = environment.baseUrl + '/api/';

// if (window.location.hostname.includes('test.fbapps')) {
//     url = environment.baseUrlFbApps + '/api/';
// }
// else if (window.location.hostname.includes('localhost')) {
//     url = environment.baseUrlTestApps + '/api/';
// }

export const LOGIN = {
    TOKEN: url + 'Token/login',
    TOKEN_TFA: url + 'Token/loginWithTFA',
    RefreshToken: url + 'Token/refreshToken',
    logout: url + 'Token/Logout',
    registerForPcb: url + 'Token/registerForPCB',
    jCBregistration: url + 'Token/JCBRegistration',
    createOrgForJCB: url + 'Token/createOrgForJCB',
}
export const USER = {
    USER_DETAILS: url + 'Account/users/me',
    changePassword: url + 'Account/public/changepassword',
    resetPassword: url + 'account/public/resetpassword',
    recoverPassword: url + 'Account/public/recoverpassword',
    userRegistration: url + 'Account/public/users',
}
export const URLS = {
    organization: url + 'V_Organization',
    organizationUsers: url + 'V_Organization/OrgUsers',
    organizationGetById: url + 'V_Organization/GetById',
    organizationAnonymousGetById: url + 'V_Organization/GetOrganizationById',
    AccountPOST: url + 'V_Organization/Account',
    MegaDashboard: url + 'V_Organization/MegaDashboardData',
    myorganization: url + 'Account/GetCurrentUserOrganizations',
    vOrgGetCurOrg: url + 'V_Organization/GetCurrentOrganization',
    SWITCH_ORG: url + 'Account/OrgCheck',
    IsProvider: url + 'V_Organization/IsProviderCompany',
    primaryCompany: url + 'V_Organization/MakePrimaryCompany',
    primaryAccountant: url + 'V_Organization/MakePrimaryAccountant',
    grantFixUncat: url + 'V_Organization/GrantFixUnCatAccess',
    Setup: url + 'V_Organization/Setup',
    AppSetup: url + 'V_Organization/AppSetup',
    allOrgsList: url + 'V_Organization/GetAllOrgsList',
    currUserAccSWs: url + 'V_Organization/currentUserAccSWs',
    allCARequest: url + 'V_Organization/AllCARequests',
    cARequestById: url + 'V_Organization/CARequests',
    makeCA: url + 'V_Organization/MakeCA',
    timeZones: url + 'V_Organization/TimeZones',
    campaignTimeZones: url + 'V_Organization/timezone',
    walletByOrg: url + 'V_Organization/AiWalletByOrg',
    walletAmount: url + 'V_Organization/WalletAmount',
    walletUpdate: url + 'V_Organization/ChangeWallet',
    mySubscriptionByOrg: url + 'V_Subscription_Reminder/AllSubscriptions',
    mySubscriptionUpdate: url + 'V_Subscription_Reminder/UpdateSubscriptionDetails/ByOrg',
    getstarted: url + 'V_Videos/ByApp',
    appInvoices: url + 'V_Invoices',
    getstartedview: url + 'V_Videos/AddView',
    getStartesApps: url + 'V_Videos/TopicsList',
    getusagemeterByOrg: url + 'V_Data_Usage_Meter/ByOrg/',
    Countrydata: url + 'V_CC_State/KSArticlesCountries',
    getHomeArticles: url + 'KS_Content_All/AccWorldArticles',
    popularArticles: url + 'KS_Content_All/AccWorldPopularArticles',
    vaichatgpt: url + 'VAIGPTChat',
    vaichatgptAssignAzureModel: url + 'VAIGPTChat/AssignAzureModel',
    smbContent: url + 'SMBContent',
    smbgptchat: url + 'SMBGPTChat',
    AaureModels: url + 'AzureModels',
    OurPricing: url + 'OurPricing',
    AIGuidelines: url + 'V_AIGuidelines',
    AIGuidelinesH: url + 'V_AIGuidelinesH',
    AIPostandGetPlayGuideline: url + 'SMBBotPlayGuidelines',
    AIGuidelinesHByCategory: url + 'V_AIGuidelinesH/ByCategory',
    AIGuidelinesHCategories: url + 'V_AIGuidelinesH/Categories',
    VAIChatGPTList: url + 'VAIGPTChat/listByCode',
    VAIChatGPTLmsBot: url + 'VAIGPTChat/LMSBots',
    AICategories: url + 'V_AIGuidelines/Categories',
    AIByCategory: url + 'V_AIGuidelines/ByCategory',
    ChatProChatGPT: url + 'SMBChatTopic/ChatProChatGPT',
    SMBCompletionProChatGpt: url + 'SMBCompletionTopic/CompletionProChatGpt',
    CompletionProChatGpt: url + 'SMBChatTopic/CompletionProChatGpt',
    TopicsHistory: url + 'SMBChatTopic/TopicsHistory',
    DeleteTopicsHistory: url + 'SMBChatTopic/topic',
    GetAllOrgsListByUser: url + 'V_Organization/GetAllOrgsListByUser',
    DeleteTopicsIndividualMessage: url + 'SMBChatTopic/topicMessage',
    AIPlayGuidelineByAiTool: url + 'SMBBotPlayGuidelines/ByAiTool',
    AIPlayGuidelineTemplate: url + 'SMBBotPlayGuidelines/Template',
    AIPlayGuidelinegetTemplatesList: url + 'SMBBotPlayGuidelines/MyTemplates',
    AIPlayGuidelinegetbyIdTemplates: url + 'SMBBotPlayGuidelines/MyTemplate',
    playPlayExemplars: url + 'SMBBotPlay/PlayExemplars',
    AIPlaydeleteGuidelineLine: url + 'SMBBotPlayGuidelines/line',
    Ai_Exemplars: url + 'V_SMBBotPlay/AddExemplars',
    deleteExemplars: url + 'V_SMBBotPlay/DeleteExemplar',
    getExemplars: url + 'SMBBotPlay/PlayExemplars',
    TopicsHistoryMessages: url + 'SMBChatTopic/TopicsHistoryMessages',
    SMBCompletionTopicHistory: url + 'SMBCompletionTopic/TopicsHistory',
    SMBBotPlayTopicHistory: url + 'SMBBotPlay/TopicsHistory',
    SMBCompletionTopicHistoryMessages: url + 'SMBCompletionTopic/TopicsHistoryMessages',
    SMBBotPlayTopicHistoryMessages: url + 'SMBBotPlay/TopicsHistoryMessages',
    DeletePlayTopicsHistory: url + 'SMBBotPlay/topic',
    DeletePlayTopicsIndividualMessage: url + 'SMBBotPlay/topicMessage',
    GuidelinesHline: url + 'V_AIGuidelinesH/line',
    AiWallet: url + 'V_Organization/AiWallet',
    AiOrgUserWallet: url + 'V_User_Profile/AiOrgUserWallet',
    AiOrgUserWalletSubscriptions: url + 'V_User_Profile/AiOrgUserWalletSubscriptions',
    AiWalletSubscriptions: url + 'V_Organization/AiWalletSubscriptions',
    Ai_V_SMBBotPlay: url + 'V_SMBBotPlay',
    AiTokensUsageSummary: url + 'SMBChatTopic/AiTokensUsageSummary',
    AiTokensUsageDetailed: url + 'SMBChatTopic/AiTokensUsageDetailed',
    AiTokensUsage: url + 'SMBChatTopic/AiTokensUsage',
    SMBBot: url + 'SMBBot',
    SMBBotPlay: url + 'SMBBotPlay',
    SMBBotPlayChatGPT: url + 'SMBBotPlay/PlayChatGPT',
    SMBAiFiles: url + 'SMBAiFiles',
    SMBStakeholdersEmployees: url + 'SMBStakeholders/employees',
    SMBStakeholdersEmployeesById: url + 'SMBStakeholders/EmployeeById',
    createQBOEmployee: url + 'SMBStakeholders/createQBOEmployee',
    UpdateQBOEmployee: url + 'SMBStakeholders/UpdateEmployee',
    UpdateStaffInEmployee: url + 'SMBStakeholders/UpdateStaffInEmployee',
    SyncEmployeesFromQBO: url + 'SMBStakeholders/SyncEmployeesFromQBO',
    SMBBotContentTarget: url + 'SMBBot/ContentTarget',
    SMBBotPlayByCode: url + 'SMBBotPlay/ByCode',
    BotChatGPT: url + 'SMBBot/BotChatGPT',
    SMBTESTBotTopicsHistoryMessages: url + 'SMBBot/TopicsHistoryMessages',
    SMBTESTBotTopicsHistory: url + 'SMBBot/TopicsHistory',
    SMBBotContentFileRemove: url + 'SMBBot/removeContentFromBot/',
    SMBBotTargetRemove: url + 'SMBBot/removeTargetFromBot/',
    EnableEmployeePortal: url + 'SMBStakeholders/EnableEmployeePortal',
    DisableEmployeePortal: url + 'SMBStakeholders/DisableEmployeePortal',
    InviteToEmployeePortal: url + 'SMBStakeholders/InviteToEmployeePortal',
    EmployeePortal: url + 'EmployeePortal/Employee',
    EmployeePortalverifyAuth: url + 'EmployeePortal/verifyAuth',
    sendVerificationCode: url + 'EmployeePortal/sendVerificationCode',
    verifyCode: url + 'EmployeePortal/verifyCode',
    PortalLogout: url + 'EmployeePortal/PortalLogout',
    AiBotsByEmployee: url + 'EmployeePortal/AiBotsByEmployee',
    EmployeeTopicsHistory: url + 'EmployeePortal/TopicsHistory',
    EmployeeTopicsHistoryMessages: url + 'EmployeePortal/TopicsHistoryMessages',
    EmployeeAiBotChatGPT: url + 'EmployeePortal/AiBotChatGPT',
    SMBAnalyzerGPT: url + 'SMBAnalyzerGPT',
    BlobUsageSummary: url + 'SMBChatTopic/AiBlobUsage',
    PostanalyzerGPT: url + 'SMBAnalyzerGPT/analyzerGPT',
    SMBAnalyzerTopicsHistory: url + 'SMBAnalyzerGPT/TopicsHistory',
    SMBAnalyzerTopicsHistoryMessages: url + 'SMBAnalyzerGPT/TopicsHistoryMessages',
    CognitiveFilesUsageSummary: url + 'SMBChatTopic/AiCognitiveFilesUsageSummary',
    AiResourceFilesUsageSummary: url + 'SMBChatTopic/AiResourceFilesUsageSummary',
    AdminsAppUsageSummary: url + 'SMBChatTopic/AdminsAppUsageSummary',
    CognitiveFilesUsageDetailed: url + 'SMBChatTopic/AiCognitiveFilesUsageDetailed',
    AiResourceFilesUsageDetailed: url + 'SMBChatTopic/AiResourceFilesUsageDetailed',
    AdminsAppUsageDetailed: url + 'SMBChatTopic/AdminsAppUsageDetailed',
    FilesMonthsYears: url + 'SMBChatTopic/ResourceFilesUsageSummaryMonthsYears',
    CognitiveMonthsYears: url + 'SMBChatTopic/AiCognitiveFilesUsageSummaryMonthsYears',
    AiTokensMonthsYears: url + 'SMBChatTopic/AiTokensUsageSummaryMonthsYears',
    AdminsMonthsYears: url + 'SMBChatTopic/AdminsAppUsageSummaryMonthsYears',
    cloneTemplate: url + 'SMBBotPlayGuidelines/CloneTemplate',
    askMeg: url + 'SMBBotPlay/askMEG',
    getGaurdianDetails: url + 'V_User_Guardians/currOrgGaurdians',
    getGaurdianCources: url + 'Google/GuardiansByStudent',
    PostGaurdians: url + 'V_User_Guardians',
    GaurdiansGetbyId: url + 'V_User_Guardians/byStudent',
    updateGuardian: url + 'V_User_Guardians/gaurdianUpdate',
    guardianPortalentityDetails: url + 'GuardianPortal/Guardian',
    guardianPortalAuth: url + 'GuardianPortal/verifyAuth',
    guardianPortalSendVCode: url + 'GuardianPortal/sendVerificationCode',
    guardianPortalVerifyCode: url + 'GuardianPortal/verifyCode',
    guardianPortalLogout: url + 'GuardianPortal/PortalLogout',
    guardianWalletAmount: url + 'GuardianPortal/GuardianWalletAmount',
    guardianWalletSubscriptions: url + 'GuardianPortal/GuardianWalletSubscriptions',
    guardianWalletPaymentsHistory: url + 'GuardianPortal/GuardianWalletPaymentsHistory',
    guardianWalletRecharge: url + 'GuardianPortal/GuardianRechargeWallet',
    guardianWallet: url + 'GuardianPortal/GuardianWallet',
    studentRoomsByGuardian: url + 'GuardianPortal/StudentRoomsByGuardian',
    enableGuardianPortal: url + 'V_User_Guardians/EnableGaurdianPortal',
    inviteGuardianPortal: url + 'V_User_Guardians/InviteToGuardianPortal',
    disableGuardianPortal: url + 'V_User_Guardians/DisableGaurdianPortal',
}

export const TableURLS = {
    dbtables: url + 'V_Tables',
}

export const QBInvoiceURLS = {
    QBInvoice: url + 'QBInvoice',
    QB_CAInvoice: url + 'QBInvoice/CAIncoices',
    QB_CBPayables: url + 'QBInvoice/CBPayables',
    QB_MyAccSWIncoices: url + 'QBInvoice/MyAccSWIncoices',

}

export const XERInvoiceURLS = {
    XeroInvoice: url + 'XeroInvoice',
    Xero_CAInvoice: url + 'XeroInvoice/CAIncoices',
}

export const FBOInvoiceURLS = {
    FBOInvoice: url + 'FBOInvoice',
    FBO_CAInvoice: url + 'FBOInvoice/CAIncoices',
}
export const VideoUrls = {
    videoInput: url + 'V_Videos',
}

export const CategoryURLS = {
    category: url + 'V_Categories',
    catgoryByApp: url + 'V_Categories/App/',
    allAppSettings: url + 'V_Global_App_Settings',
    // htAppSettings: url + 'V_Global_App_Settings/MyFrameworkSettings',
    // htAppSetting: url + 'V_Global_App_Settings/FrameworkSetting',
    vGlobalAppClonetoOrg: url + 'V_Global_App_Settings/CloneAppSettingToOrgs',
    localCat: url + 'V_Categories_Local',  ///new create
    localCatByApp: url + 'V_Categories_Local/CurrOrgCategories/',
    localCatType: url + 'V_Categories_Local/CategoryByTypeNapp',
    appSettings: url + 'V_Global_App_Settings/AppCurrOrg/',
    groups: url + 'V_User_Groups',
    groupByAppCode: url + 'V_User_Groups/currOrgGroups',
    teamBYGroup: url + 'V_User_Groups/TeamByGroup',
    groupList: url + 'V_User_Groups/GroupsList',
    allgroupList: url + 'V_User_Groups/AllGroupsList',
    teamByAppCode: url + 'V_User_Groups/currOrgGroupTeam',
    teamMemberDelete: url + 'V_User_Groups/groupTeam',
    teamLead: url + 'V_User_Groups/TeamLeads',
    groupDelete: url + 'V_User_Groups/group',
    fileRemove: url + 'FilesAttachement/AppFile/Delete',
    fileRemoveAppcode: url + 'FilesAttachement/File/Delete',
    getEmailtype: url + 'EC_Emails/CurrOrgEmailsList',

}

export const NotificationURLS = {
    notification: url + 'V_Notification',
    notificationClear: url + 'V_Notification/clear',
    notificationByOrg: url + 'V_Notification/ByCurrentOrg',
    clearAll: url + 'V_Notification/ClearAllNotifications',
    userLog: url + 'V_All_Services_Log/userLog',
    sendEMailsToUsers: url + 'V_Notification/sendEmailsToUsers',
    appcodeNotifications: url + 'V_Notification/ByApp',
    allAppsCount: url + 'V_Notification/AllAppsCount'

}

export const ContactURLS = {
    contact: url + 'V_Contact',
    supportComment: url + 'V_Contact/Comment',
    supportCommentsGet: url + 'V_Contact/Comments',
    supportUpVote: url + 'V_Contact/Vote',
    addRemarks: url + 'V_Contact/addRemarks',
    supportShowToPublic: url + 'V_Contact/ShowToPublic',
    replayAnswer: url + 'V_Notification/Reply/ContactOrFeedback',
    userFeedback: url + 'V_Customer_Feedback',
    htmHelp: url + 'V_User_Help',
    searchHelp: url + 'V_User_Help/SearchHelp',
    pageHelp: url + 'V_User_Help/PageSearch',
    subjectsGet: url + 'V_User_Help/GetAllSubjects',
    cARequest: url + 'V_Contact/CA_Request',
    supportSummary: url + 'V_Contact/SupportSummary',
    teamSummary: url + 'V_Contact/TeamSummaryDetail',
}
export const AppUrl = {
    Appservice: url + 'V_Apps',
    appList: url + 'V_Apps/AppsList',
    App: url + 'V_App_Country_Map',
    AVAILABLE_APPS: url + 'V_App_Country_Map/AvaliableApps',
    uninstalledApps: url + 'V_IAS_User_Map/MyUnInstalledApps',
    APP_Subscription: url + 'Stripe/AppSubscription',
    APP_SubscriptionFromCard: url + 'Stripe/AppSubscriptionFromCard',
    AVAILABLE_Services: url + 'V_App_Country_Map/AvaliableServices',
    CommingSoonApps: url + 'V_App_Country_Map/CommingSoonApps',
    CommingSoonServices: url + 'V_App_Country_Map/CommingSoonServices',
    installedApps: url + 'V_IAS_User_Map/MyInstalledApps',
    myApps: url + 'V_IAS_User_Map/MyInstalledViewDataApps',
    recommendedApps: url + 'V_App_Country_Map/MyRecommendedApps',
    appByACMId: url + 'V_App_Country_Map/AppbyUserACM',
    installedServices: url + 'V_IAS_User_Map/MyFirmPaidServices',
    firmApps: url + 'V_IAS_User_Map/MyFirmApps',
    INSTALL_APP: url + 'V_IAS_User_Map',
    INSTALL_Firm_APP: url + 'V_IAS_User_Map/InstallFirmApp',
    INSTALL_UnInstalled_APP: url + 'V_IAS_User_Map/install',
    Invoice: url + 'V_Interface_Invoice',
    myInvoice: url + 'V_Interface_Invoice/CurrentOrg',
    myInvoicecurOrg: url + 'V_Interface_Invoice/CurrOrgSalesReceipts',
    currOrgMyExpenses: url + 'V_Pay_Info_Batch/CurrOrgExpense',
    allAppPayments: url + 'V_Pay_Info',
    frameworkServiceLog: url + 'V_All_Services_Log',
    frameworkWebhookLog: url + 'V_All_Services_Log/webhookLog',
    frameworkUserLog: url + 'V_All_Services_Log/userLog',
    myInvoiceId: url + 'V_Interface_Invoice/GetExpenseById',
    // mySales: url + 'V_Interface_Invoice/CurrOrgSalesReceipts',
    // mySalesId: url + 'V_Interface_Invoice/GetSalesReceiptById',
    myJournalEntries: url + 'V_Pay_Info_Batch/myIncome',
    mySubscription: url + 'V_Subscription_Reminder/CurrentOrg',
    unSubscribe: url + 'V_Subscription_Reminder/UpdateSubscriptionStatus',
    subscriptionHistory: url + 'V_Subscription_Reminder/SubscriptionsHistory',
    APPS_BY_USER: url + 'Account/GetTeam/Apps',
    AllAspRoles: url + 'Account/AllAspRoles/Dropdown',
    getAppRoles: url + 'Account/AppRolesByUserapp',
    UpdateAppRoles: url + 'Account/AppRolesByUser',
    APP_RATING: url + 'V_App_Rating',
    deleteAppRole: url + 'V_App_Roles',
    AppsSettingsCategories: url + 'V_Apps/SettingsOrCategoriesAppsList',
    service: url + 'V_Services',
    serviceApp: url + 'V_Services/Approved',
    serviceLines: url + 'V_Service_Lines',
    serviceLinesbyId: url + 'V_Service_Lines/ServiceLines',
    serviceSearch: url + 'V_Services/Search',
    providersearch: url + 'OM_SP_Services/ProviderServiceSearch',
    omInvoice: url + 'OM_SP_Cust_Services/MyIncomeInvoices',
    omExpense: url + 'M_SP_Cust_Services/MyExpenseInvoices',
    servicePending: url + 'V_Services/Pendig',
    serviceBank: url + 'V_Services_Bank',
    serviceBankListbyAppCode: url + 'V_Services_Bank/BankListByAppCode',
    ServiceBanksteps: url + 'V_Services_Bank_Steps',
    ServiceBankstepsGet: url + 'V_Services_Bank_Steps/ServiceBankSteps',
    vOrgIncomeExpensesAccount: url + 'V_Organization/IncomeExpenseAccounts',
    vCatLAppListwithCattype: url + 'V_Categories_Local/AppsListWithCatType',
    acSpStaffPerfByUSerId: url + 'AC_SP_Staff_Performance/ByUserId',
    apSpRetainerByCustomer: url + 'AC_SP_Retainer/ByCustomer',
    apspRetainerLines: url + 'AC_SP_Retainer/RetainerLine',
    unSubscribeApp: url + 'V_Subscription_Reminder/AutoRenewal',
    vAppsAccountantInstalledApps: url + 'V_Apps/AccountantInstalledAppsList',
    stakeholders: url + 'EQ_Stakeholder',
    sharesTransfer: url + 'EQ_Stakeholder/transfer',
    stakeholdersActivities: url + 'EQ_Stakeholder/activity',
    stakeholdersCurrOrgUser: url + 'EQ_Stakeholder/currOrgUser',
    stakeholderRulesDropdown: url + 'EQ_Master_Rules/dropdown',
    htmlTemplates: url + 'V_HTML_Templates',
    htmlTemplatesForCACB: url + 'V_HTML_Templates/ListByType',
    htmlTemplatesAddToEmailTemplate: url + 'V_HTML_Templates/AddToEmailTemplates',

}
export const QBUrls = {
    qbItems: url + 'QBItems',
    qbItemsCurrent: url + 'QBItems/CurrOrg',
    qbItemsCat: url + 'QBItems/Category',
}

export const CCStateUrl = {
    ccState: url + 'V_CC_State',
    countryCurrency: url + 'V_CC_State/Countries',
    countryList: url + 'V_CC_State/CountriesList',
    countryState: url + 'V_CC_State/States'
}

export const TEAM_URL = {
    Team: url + 'Account/GetTeam/users',
    TeamByUser: url + 'Account/GetTeamByUser',
    ADD_USER: url + 'Account/AddStaff/users',
    ADD_MENTOR: url + 'Account/AddMentors/users',
    update_User: url + 'Account/PutTeam/users',
    delete_User: url + 'Account/DeleteTeam/User',
    ARC: url + 'Account/ARC',
    ArcCurrent: url + 'Account/ARC/CurrentUser',
    roletransfer: url + 'Account/Team/ExchangeRoles',
    activeInactive: url + 'Account/Team/ActiveOrInactiveUser',
    accountResendInvitation: url + 'Account/ResendInvitation',
}

export const ForgetUrl = {
    forget: url + 'Account/public/recoverpassword',
    confirmEmail: url + 'Account/public/confirmemail'
}

export const UserProfileURL = {
    profile: url + 'V_User_Profile',
    profileAllStaffBillingRates: url + 'V_User_Profile/AllStaffBillingRates',
    profileStaffBillingRates: url + 'V_User_Profile/StaffBillingRate',
    accCompanyBillingRate: url + 'V_Organization/companyBillingRate',
    userProfiles: url + 'V_User_Profile/AllAccUserProfilesByCurrOrg',
    profileByUrl: url + 'V_User_Profile/AdvisorProfilesListByUrl',
    updateRefererUrl: url + 'EQ_Stakeholder/referral',
    accUserProfile: url + 'V_User_Profile/AccUserProfile',
    updateSignature: url + 'V_User_Profile/UpdateSignature',
    accUserProfileCurrentOrg: url + 'V_User_Profile/AllAccUserProfilesByCurrOrg',
    accUserProfileByUserGet: url + 'V_User_Profile/AccUserProfileByUser', // ?OrgId
    accCompanyProfileByorg: url + 'V_Organization/AccCompanyProfile',
    accOrgProfileUpdate: url + 'V_Organization/AccOrgProfile',
    accOrgProfileByUser: url + 'V_User_Profile/byUser',
    acceptGuidelinesByUser: url + 'V_User_Profile/AcceptGuidelines',

}
export const QbConnectURL = {
    callbackUrl: url + 'Account/CallBack',
    QuikBookUrl: url + 'Account/QuickBookUrl',
    qbDissconnect: url + 'Account/QbDisconnect',
    openIdUrl: url + 'Account/OpenIdUrl',
    openId: url + 'Account/OpenId',
    disconnectUrl: url + 'Account/DisconnectUrl',
    dissconnect: url + 'Account/Disconnect',
    identityConfirm: url + 'Account/IndetityConfirm'
}
export const FbConnectURL = {
    openId: url + 'FreshBooks/OpenId',
    callbackUrl: url + 'FreshBooks/FBCallBack',
    getOrgs: url + 'FreshBooks/FBGetOrgs',
    getMyTeam: url + 'FreshBooks/MyTeam',
    identityConfirm: url + 'Account/IndetityConfirm',
    createOrg: url + 'FreshBooks/CreateOrg',
    createOrgAfterCallBack: url + 'FreshBooks/afterCallBack'
}
export const XeroConnectURL = {
    callbackUrl: url + 'Xero/CallBack',
    XeroUrl: url + 'Xero/xeroOauthUrl',
    openIdUrl: url + 'Xero/OpenIdUrl',
    openId: url + 'Xero/OpenId',
    xerodissconnect: url + 'Xero/Disconnect',
}

export const clientPortal = {
    portalStripe: url + 'ClientPortal/Stripe',
    stripePayment: url + 'ClientPortal/payment',
    paymentMethods: url + 'ClientPortal/PaymentMethods',
    pbcListForClientPortal: url + 'ClientPortal/clienttasks',
    updatetasknotesClientPortal: url + 'ClientPortal/updatetasknotes',
    updateupdatetaskstatusClientPortal: url + 'ClientPortal/updatetaskstatus',
    portalPbcListsLineReply: url + 'ClientPortal/clienttaskssubmit',
    portalPbcdashboardJobs: url + 'ClientPortal/dashboardJobs',
    portalpbcFileDelete: url + 'ClientPortal/clienttasksfile/Delete',
    clientPortalverifyAuth: url + 'ClientPortal/verifyAuth',
    clientPortalentityDetails: url + 'ClientPortal/getEntityDetails',
    clientPortalsendCodeToMail: url + 'ClientPortal/sendVerificationCode',
    verifyCode: url + 'ClientPortal/verifyCode',
    portalLogout: url + 'ClientPortal/PortalLogout',
    clientPortalPayable: url + 'ClientPortal/CAIncoices',
    clientPortalPayableById: url + 'ClientPortal/Incoice',
    clientPortalSubscriptions: url + 'ClientPortal/CACBSubscriptions',
    clientPortalSubscriptionById: url + 'ClientPortal/CACBSubscriptionsById',
    clientSubscriptionPayment: url + 'ClientPortal/CreateStripeSubscription',
    clientSubscriptionPaid: url + 'ClientPortal/SubmitSubscription',
    PortalDashboardCounters: url + 'ClientPortal/PortalDashboardCounters',
    clientPortalChat: url + 'ClientPortal/PostChat',
    clientPortalGetChat: url + 'ClientPortal/Chat',
    clientPortalproposalsByClient: url + 'ClientPortal/proposalsByClient',
    clientPortalAiBotsByClient: url + 'ClientPortal/AiBotsByClient',
    clientPortalTopicsHistory: url + 'ClientPortal/TopicsHistory',
    clientPortalTopicsHistoryMessages: url + 'ClientPortal/TopicsHistoryMessages',
    AiBotChatGPT: url + 'ClientPortal/AiBotChatGPT',
}
export const SubcriptionReminder = {
    stripe: url + 'Stripe/Stripe',
    stripeAccountDetails: url + 'Stripe/StripeAccount',
    stripeProductDetails: url + 'Stripe/GetStripePricesList',
    stripeCustomersDetails: url + 'Stripe/GetStripeCustomers',
    stripeSubscriptionDetails: url + 'Stripe/GetStripeSubscriptions',
    stripeSubscriptionListDetails: url + 'Stripe/GetStripeSubscriptionLines',
    stripeAdvisor8Customers: url + 'Stripe/GetAdvisor8StripeCustomers',
    payment: url + 'Stripe/payment',
    stripeSetupIntent: url + 'Stripe/setupIntent',
    stripeSubmitSetupIntent: url + 'Stripe/submitSetupIntent',
    clientSubscriptionPayment: url + 'Stripe/CreateStripeSubscription',
    clientSubscriptionPaid: url + 'Stripe/SubmitSubscription',
    paymentMethods: url + 'Stripe/PaymentMethods',
    CART: url + 'V_Subscription_Reminder/CheckOut',
    CARTById: url + 'V_Subscription_Reminder/CheckOutLines',
    REMOVE_APP_FROM_CART: url + 'V_Subscription_Reminder',
    previousTransactions: url + 'V_Stripe/ByOrg',
    sripeStandardUrl: url + 'Stripe/StripeStandardUrl',
    stripePriceList: url + 'Stripe/GetStripePricesList',
    getClientSuscriptions: url + 'Stripe/CACBSubscriptions',
    postClientSuscription: url + 'Stripe/CreateClientSubscription',
    ClientSuscriptionById: url + 'Stripe/CACBSubscriptionsById',
    StripePaymentMethods: url + 'Stripe/CurrOrgPaymentMethods',
    SaveCardPayemntIntent: url + 'Stripe/submitSetupIntentByPaymentMethod',
    MakePrimaryCardPayemntIntent: url + 'Stripe/MakeStripeCardPrimary',
    RemoveCardPayemntIntent: url + 'Stripe/RemovePaymentMethod',
    RechargeWallet: url + 'Stripe/rechargeWallet',
    WalletPaymentHistory: url + 'Stripe/WalletPaymentsHistory',
    OrgUserRechargeWallet: url + 'V_User_Profile/OrgUserRechargeWallet',
    OrgUserWalletPaymentHistory: url + 'V_User_Profile/OrgUserWalletPaymentsHistory',
    WalletHonTruPrices: url + 'Stripe/GetHonTruWalletPricesList',
    GetWalletSubscription: url + 'Stripe/GetWalletStripeSubscription',
    CancelSubscription: url + 'Stripe/ChangeStripeSubscription',
    rechargeWalletFromCard: url + 'Stripe/rechargeWalletFromCard',
    CashFreeRechargeWallet: url + 'Cashfree/CreateOrder',
    CashFreeCreateOrderSplit: url + 'Cashfree/CreateOrderSplit',
    CashFreeCreateVendor: url + 'Cashfree/CreateVendor',
    GetMyVendorDetails: url + 'Cashfree/GetMyVendorDetails',
    UpdateVendorDetails: url + 'Cashfree/UpdateVendor',
    CashFreeWalletUpdate: url + 'Cashfree/UpdateWalletByOrder',
    CashFreeOrgUserWalletUpdate: url + 'Cashfree/UpdateOrgUserWalletByOrder',
    RazorPayWalletUpdate: url + 'Razorpay/UpdateWalletByPayment',
    CashFreeOrderSplitStatusUpdate: url + 'Cashfree/UpdatePaymentByOrderSplit',
    RazorPayRechargeWallet: url + 'Razorpay/CreateOrder',
    RazorpayPlans: url + 'Razorpay/Plans',
    RazorpayCreateSubscription: url + 'Razorpay/CreateSubscription',
    CancelRazorpaySubscription: url + 'Razorpay/CancelSubscription',


}

export const UsageMeter = {
    masterurl: url + 'V_Data_Usage_Master'
}

// knowledge Share
export const KSURLS = {
    Content_All: url + 'KS_Content_All/Tests',
    advancesearch: url + 'KS_Content_All/Search',
    contentSearch: url + 'KS_Content_All/ContentSearch',
    advisorSearch: url + 'KS_Content_All/AdvisorSearch',
    ContentById: url + 'KS_Content_All/CurrentUserPendingArticles',
    shareById: url + 'KS_Content_All/Tests',
    articlesByAdvisorGroup: url + 'KS_Content_All/ArticlesByGroup',
    KS_Content_All: url + 'KS_Content_All/Writer/Post',
    putkscontentall: url + 'KS_Content_All',
    deleteContent: url + 'KS_Content_All/HardDelete',
    draftkscontentall: url + 'KS_Content_All/Draft',
    currentUserContentAll: url + 'KS_Content_All/CurrentUserContentAll',
    currentOrgContentAll: url + 'KS_Content_All/CurrentOrgContentAll',
    followers: url + 'KS_User_Connect/Follower',
    following: url + 'KS_User_Connect/Following',
    myFavorites: url + 'KS_User_Connect/MyFavorites',
    myDrafts: url + 'KS_Content_All/CurrentUserDrafts',
    myPendings: url + 'KS_Content_All/CurrentUserPendingArticles',
    KS_User_Connect: url + 'KS_User_Connect',
    like: url + 'KS_Content_Likes/Like',
    disLike: url + 'KS_Content_Likes/Dislike',
    unfavorite: url + 'KS_User_Connect/UnFavorite',
    inAppropriate: url + 'KS_User_Connect/Inappropriate',
    unFollow: url + 'KS_User_Connect/UnFollow',
    comments: url + 'KS_Comments',
    commentsByContentid: url + 'KS_Comments/Comments',
    networkdisconnect: url + 'KS_User_Network/RemoveConnection',
    remarksByContentid: url + 'KS_Content_Remarks/Remarks',
    ksSetupNotifications: url + 'KS_Setup/notificationsettings',
    ksSetupnotificationsettingsByStaff: url + 'KS_Setup/notificationsettingsByStaff',
    getksResponsiblities: url + 'KS_Setup/ResponsibilitiesByStaff',
    updateksResponsiblities: url + 'KS_Setup/UpdateResponsibility',
    postPackage: url + 'KS_Setup/package',
    postService: url + 'KS_Setup/service',
    getService: url + 'KS_Setup/Services',
    getServiceByOrg: url + 'KS_Setup/ServicesByOrg',
    getServiceByOrgProfile: url + 'KS_Setup/ServicesByOrgProfile',
    getServiceCertifications: url + 'KS_Setup/Certifications',
    ServiceCertificationGetbyid: url + 'KS_Setup/Certification',
    updateServiceCertifications: url + 'KS_Setup/IssueCertificate',
    updatService: url + 'KS_Setup/service',
    updatePackage: url + 'KS_Setup/package',
    getPackages: url + 'KS_Setup/packages',
    assignServicesToPackage: url + 'KS_Setup/AssignServicesToPackage',
    assignRoomsToPackage: url + 'KS_Setup/AssignRoomsToPackage',
    assignRoomsToService: url + 'KS_Setup/AssignRoomsToService',
    getMyFavPromptTemplates: url + 'KS_User_Favorites/MyFavPromptTemplates',
    assignRoomsToServiceIndia: url + 'KS_Setup/RoomsByServiceForIndia',
    getServicesByPackageId: url + 'KS_Setup/ServicesByPackage',
    deleteAssigedService: url + 'KS_Setup/DeleteAssignedService',
    getRoomsByPackage: url + 'KS_Setup/RoomsByPackage',
    getRoomsByService: url + 'KS_Setup/RoomsByService',
    getServicesByRoom: url + 'KS_Setup/ServicesByRoom',
    remarks: url + 'KS_Content_Remarks',
    toBeReviwed: url + 'KS_Content_All/GetPendingArticlesByCurrentUserRole',
    reviewed: url + 'KS_Content_All/GetApprovedArticlesByCurrentUser',
    pendings: url + 'KS_Content_All/GetRemarkedArticlesByCurrentUser',
    approveContent: url + 'KS_Content_All/Status',
    postInviteConnection: url + 'KS_User_Network/ConnectionInvite',
    myConnectedAdvisors: url + 'KS_User_Network/MyConnected',
    RateMentor: url + 'KS_User_Network/RateMentor',
    aiRoom: url + 'KS_AI_Rooms/Room',
    makeAsCoAssistant: url + 'KS_AI_Rooms/MakeCoAssistant',
    PostSubjectandtopic: url + 'KS_AI_RoomPostSubjectTopics/CreateSubjectTopics',
    PostTopic: url + 'KS_AI_RoomPostSubjectTopics/CreateTopic',
    PostTopicCreate: url + 'KS_AI_RoomPostSubjectTopics/CreateTopic',
    PostSubjectCreate: url + 'KS_AI_RoomPostSubjectTopics/CreateSubject',
    GetPostSubject: url + 'KS_AI_RoomPostSubjectTopics/SubjectsByRoom',
    GetTopic: url + 'KS_AI_RoomPostSubjectTopics/TopicsBySubject',
    updateTopic: url + 'KS_AI_RoomPostSubjectTopics/Topic',
    updateRoomTopic: url + 'KS_AI_RoomPosts/PostTopic',
    updateRoomSubject: url + 'KS_AI_RoomPostSubjectTopics/Subject',
    deleteRoomSubject: url + 'KS_AI_RoomPostSubjectTopics/Delete',
    InitialJoinRoom: url + 'KS_AI_Rooms/FirstJoinRooms',
    RoomsByMentor: url + 'KS_AI_Rooms/RoomsByMentor',
    aiRoomById: url + 'KS_AI_Rooms',
    myAiRooms: url + 'KS_AI_Rooms/Rooms',
    allAiRooms: url + 'KS_AI_Rooms/RoomsSearch',
    myAiRoomInvite: url + 'KS_AI_Rooms/RoomInvite',
    myAiRoomsManage: url + 'KS_AI_Rooms/MyRoomsManageByRoom',
    myAiRoomsAccept: url + 'KS_AI_Rooms/RoomAcceptOrIgnore',
    AiRoomInvitationWithdraw: url + 'KS_AI_Rooms/RoomWithdraw',
    leaveAiRoom: url + 'KS_AI_Rooms/RemoveFromRoom',
    aiRoomMembers: url + 'KS_AI_Rooms/MyRoomMembers',
    aiRoomHistory: url + 'KS_AI_Rooms/RoomHistory',
    postRoomInviteBulk: url + 'KS_AI_Rooms/RoomInviteBulk',
    getShareRoomDetails: url + 'KS_AI_Rooms/share',
    getRoomSettings: url + 'KS_AI_Rooms/Settings',
    updateRoomSettings: url + 'KS_AI_Rooms/updateSettings',
    myConnectionManage: url + 'KS_User_Network/MyConnectionManage',
    myHashtags: url + 'KSHashtags/MyHashTags',
    getMastertags: url + 'KSHashtags',
    withdrawConnection: url + 'KS_User_Network/ConnectionWithdraw/',
    acceptOrIngoreConnection: url + 'KS_User_Network/ConnectionAcceptOrIgnore/',
    advisor_profile: url + 'V_User_Info/AdvisorProfileByUrl',
    getUserSkillsGoals: url + 'KS_User_Network/UserSkillsGoals',
    AllMyReviews: url + 'KS_User_Network/AllMyReviews',
    getUserSkillsGoalsTag: url + 'KS_User_Network/UserSkillsGoals/tag',
    getUserSkillsGoalsByUser: url + 'KS_User_Network/UserSkillsGoalsByUser',
    updateUserSkillsGoals: url + 'KS_User_Network/UpdateUserSkillsGoals',
    getFavoriteTools: url + 'KS_User_Favorites/MyFavAiTools',
    unFavoriteTools: url + 'KS_User_Favorites/UnfavoriteAiTool',
    getFavoriteBots: url + 'KS_User_Favorites/MyFavAiBots',
    getFavoriteBotGroups: url + 'KS_User_Favorites/MyFavAiBotGroups',
    postFavoriteBots: url + 'KS_User_Favorites/Favorite',
    getFavoriteBotNotes: url + 'KS_User_Favorites/MyFavAiBotNotes',
    getFavoriteRooms: url + 'KS_User_Favorites/MyFavStudyRooms',
    unFavoriteBots: url + 'KS_User_Favorites/UnfavoriteAiBot',
    unFavoriteBotGroups: url + 'KS_User_Favorites/UnfavoriteAiBotGroup',
    unFavoriteNotes: url + 'KS_User_Favorites/UnfavoriteAiBotNotes',
    unFavoriteRooms: url + 'KS_User_Favorites/UnfavoriteStudyRoom',
    servicecheckout: url + 'KS_Payments/checkout',
    servicecheckoutPayment: url + 'KS_Payments/payment',
    serviceStripeCheckout: url + 'KS_Payments/StripeCheckout',
    servicecheckoutStripe: url + 'KS_Payments/Stripe',
    myPayments: url + 'KS_Payments/MyPayments',
    myIncome: url + 'KS_Setup/MyOrgIncome',
    myExpenses: url + 'KS_Setup/MyOrgExpenses',
    myExpensesgetById: url + 'KS_Setup/MyOrgExpense',
    // localCat: url + 'KS_Local_Categories',
    // CurrentLocalCat: url + 'KS_Local_Categories/CurrOrgCategories'
    myFavHistory: url + 'KS_User_Favorites/MyFavHistory',
    multipleRemoveMemb: url + 'KS_AI_Rooms/RemoveMultiple',
}
// Dynamic Forms

export const DfUrls = {
    questionBankurl: url + 'DFQuestionBank',
    questions: url + 'DFQuestions',
    questionsByForm: url + 'DFQuestions/ByFormId',
    DFForms: url + 'DFForms',
    activeForm: url + 'DFForms/ActiveOrInactiveForm',
    MyDFForms: url + 'DFForms/CurrOrgFormsList',
    CustomFieldsPost: url + 'DFCustomFields',
    CustomFieldsGet: url + 'DFCustomFields/CurrOrg',
    CustomFieldsGetByClient: url + 'DFCustomFields/ByClient',
    publicForms: url + 'DFForms/PublicForms',
    myForms: url + 'DFForms/CurrOrgForms',
    dfFormsAssignedToTeamMember: url + 'DFForms/AssignedFormsByTeamUser',
    formClientsList: url + 'DFForms/CurrOrgContactsList',
    addToMyForm: url + 'DFForms/templates',
    answers: url + 'DFAnswers',
    options: url + 'DFOptions',
    answersByFormId: url + 'DFAnswers/ByFormId',
    sendForms: url + 'DFSendForms',
    sendFormById: url + 'DFSendForms/SendForms/Form',
    sendFormsById: url + 'DFSendForms/SendForms',
    formbytocken: url + 'DFAnswers/ValidateFormFilling',
    getanswers: url + 'DFSendForms/GetAnswers',
    assignToClients: url + 'DFFormClientMap',
    deleteAssignedToMember: url + 'DFFormClientMap/DeleteAssigned'
}
export const DATA_USAGE_URLS = {
    USAGE: url + 'V_Data_Usage_Meter/CountByCurrentOrg',
    DASHBOARD: url + 'V_Data_Usage_Meter/MainDashboard'

}

// Mobile Web

export const MobileWeb = {
    screenContent: url + 'MW_Screen_Content',
    mwApps: url + 'MW_Apps',
    myMwApps: url + 'MW_Apps/MyApp',
    menuItems: url + 'MW_Menu_Items',
    appSubmition: url + 'MW_Apps/AppSubmition',
    buyMobilePackage: url + 'MW_Apps/BuyMobilePackage',
    developerApps: url + 'MW_Apps/SubmittedApps',
    devStatusChange: url + 'MW_Apps/AppStatus',
    publishApp: url + 'MW_Apps/AppPublish'
}


// Business Directory

export const BusinessDirectory = {
    entities: url + 'BD_Entities',
    entitySearch: url + 'BD_Entities/Search',
    NAICS_Search: url + 'BD_Entities/NAICS_Search',
    industrySearch: url + 'BD_Entities/Industry_Search',
    addToFvtEnity: url + 'BD_Fav_Entity_Map',
    unFavtEnity: url + 'BD_Fav_Entity_Map/UnFavouriteEntity',
    myFavtEnity: url + 'BD_Fav_Entity_Map/MyFavouriteEntities',
    entityList: url + 'BD_Org_Entities/currOrgQBCustomers',
    entityRelation: url + 'BD_EntityRelation',
    entityNotes: url + 'BD_EntityNotes',
    enableClientPortal: url + 'BD_Org_Entities/EnableClientPortal',
    enableClientContactPortal: url + 'BDOEM_Contact/EnableClientContactPortal',
    disableClientPortal: url + 'BD_Org_Entities/DisableClientPortal',
    disableClientContactPortal: url + 'BDOEM_Contact/DisableClientContactPortal',
    inviteClientPortal: url + 'BD_Org_Entities/InviteToClientPortal',
    addToCrm: url + 'BD_Entities/AddContactToCRM',
    addToEC: url + 'BD_Entities/AddContactToEC'
}

// Project Management
export const ProjectManagement = {
    pmProjects: url + 'PM_Projects',
    privateProjects: url + 'PM_Projects/PrivateProjects',
    byorgTeam: url + 'V_User_Groups/CurrentOrgTeam',
    teamByProject: url + 'PM_Projects/ProjTeam',
    groupByProject: url + 'PM_Groups/Groups',
    byorgProjects: url + 'PM_Projects/CurrentOrgProjects',
    projectTeam: url + 'PM_Project_Team',
    bypmTeam: url + 'PM_Projects/ProjTeam',
    pmDesignition: url + 'PM_Designation',
    // pmDesignitions: url + 'PM_Local_Categories/Type',
    // pmDesignitioncategories: url + 'PM_Local_Categories',
    // pmAllAppSeetings: url + 'PM_App_Settings',
    // pmAppsettings: url + 'PM_App_Settings',
    // orgCategorys: url + 'PM_Local_Categories/Currorg',
    // pmAppSetCuurentOrg: url + 'PM_App_Settings/Currorg',
    pmGroups: url + 'PM_Groups',
    groupTeamLead: url + 'PM_Groups/TeamLead',
    pmGroupTeam: url + 'PM_Group_Team',
    bypmGroups: url + 'PM_Groups/ProjGroups',
    mileStones: url + 'PM_Milestones',
    pmMileStones: url + 'PM_Milestones/milestones',
    milestoneDropdown: url + 'PM_Milestones/getmilestone',
    Tasks: url + 'PM_Tasks',
    pmTasks: url + 'PM_Tasks/MyTasks',
    teamByProjectCount: url + 'PM_Tasks/mytaskscount',
    pmGroupTasks: url + 'PM_Tasks/MyGroupTasks',
    jobTasksApprovals: url + 'PM_Job_Task/TaskApprovalByTask',
    groupByProjectCount: url + 'PM_Tasks/grouptaskscount',
    pmAllTasks: url + 'PM_Tasks/Tasks',
    allTasksCount: url + 'PM_Tasks/Taskscount',
    closedTasksCount: url + 'PM_Tasks/ClosedTaskscount',
    pmLines: url + 'PM_Project_Lines/ProjectLinesByProject',
    pmLine: url + 'PM_Project_History/ProjectLinesByProject',
    taskLines: url + 'PM_Task_Lines/tasklines',
    taskline: url + 'PM_Task_History/tasklines',
    commentLines: url + 'PM_Comments/comments',
    comments: url + 'PM_Comments',
    pmCommentByJob: url + 'PM_Comments/ByJob',
    pmCommentsByJobTask: url + 'PM_Comments/ByJobTask',
}

// email read
export const EmailRead = {
    emilRead: url + 'ER_Pop_Settings',
    emailpopGet: url + 'EmailContent/PopSettings',
    emailContentByid: url + 'EmailContent',
    emailContent: url + 'EmailContent/GetAllBoxList',
    emailBox: url + 'EmailContent/EmailBox',
    unread: url + 'EmailContent/UpdateStatus',
    orgPopDropdown: url + 'ER_Pop_Settings/byOrg',
    erOrgPopEmailMap: url + 'ER_Org_Pop_Email_Map',
    erOrgPopEmailMapMyPopEm: url + 'ER_Org_Pop_Email_Map/MyPopEmailMappings',
    erOrgTransaction: url + 'ER_Org_Trx_Email_Map/MyEmailTransations',
    erOrgEmailMapTransaction: url + 'ER_Org_Trx_Email_Map/Transactions',
    erOrgEmailMap: url + 'ER_Org_Trx_Email_Map',
    erSendTransaction: url + 'ER_Org_Trx_Email_Map/SendTransactionToQB',
    erPopDefaultSettings: url + 'ER_Pop_Settings/DefaultPopSettings',
    // erPopSettings: url + 'ER_Pop_Settings/byOrg',
    // ER_Org_Trx_Email_Map/Transactions
}

// Email campaign

export const EmailCampaign = {
    templates: url + 'EC_Email_Templates',
    templatesByCode: url + 'EC_Email_Templates/Code',
    templatesGrapeJS: url + 'EC_Email_Templates/GrapeJS',
    templatesRemove: url + 'EC_Email_Templates/remove',
    templateThumbnail: url + 'EC_Email_Templates/thumbnailById',
    templateDropdown: url + 'EC_Email_Templates/MyEmailTemplates',
    templateDropdownList: url + 'EC_Email_Templates/EmailTemplatesDropdown',
    // myTemplates: url + 'EC_Email_Templates/MyEmailTemplates',
    orgEntities: url + 'EC_Email_Attributes/ListOfEnities',
    attributes: url + 'EC_Email_Attributes/Attributes',
    // category: url + 'EC_Local_Categories',
    // catType: url + 'EC_Local_Categories/Category',
    // orgCat: url + 'EC_Local_Categories/CurrOrgCategories',
    // allAppSettings: url + 'EC_App_Settings',
    // appSettings: url + 'EC_App_Settings/CurrOrg',
    campaigns: url + 'EC_Email_Campaigns',
    htCampaigns: url + 'EC_HT_Email_Campaigns',
    htmlTemplateThumbnail: url + 'V_HTML_Templates/thumbnailById',
    campaignStatus: url + 'EC_Email_Campaigns/Status',
    campaignGroupDelete: url + 'EC_Email_Campaigns/campaign_group',
    htCampaignStatus: url + 'EC_HT_Email_Campaigns/Status',
    myCampaigns: url + 'EC_Email_Campaigns/CurrOrgCampaigns',
    htCampaignsGet: url + 'EC_HT_Email_Campaigns/HTCampaigns',
    campaignList: url + 'EC_Email_Campaigns/CurrOrgCampaignsList',
    byEmails: url + 'EC_Email_Campaigns/EmailsList',
    usage: url + 'EC_Email_Campaigns/Usage',
    historyCampaigns: url + 'EC_Email_Campaigns/History',
    htHistoryCampaigns: url + 'EC_HT_Email_Campaigns/History',
    emails: url + 'EC_Emails',
    mycontactGroups: url + 'EC_Emails/MyContactGroups',
    mycontactGroupsList: url + 'EC_Emails/MyContactGroupsList',
    contactGroup: url + 'EC_Emails/ContactGroup',
    importContacts: url + 'EC_Emails/ImportContacts',
    qbContacts: url + 'QBI_CustomerInterface/GetCurrOrgContacts',
    groupContactsList: url + 'EC_Emails/CurrOrgContactsList',
    emailBankPost: url + 'EC_Emails',
    assignContactsToGroup: url + 'EC_Emails/assignContacts',
    unsubscribeEmails: url + 'EC_Emails/IsUnsubscribeEmails',
    getCompanyByECGMId: url + 'EC_Emails/OrgDetailsByECGId',
    automatons: url + 'EC_Automation',
    automatonLines: url + 'EC_Automation/Line',
    automatonStatus: url + 'EC_Automation/Status',
    automatonLineStatus: url + 'EC_Automation/LineStatus',
    automatonById: url + 'EC_Automation/AutomationById',
    myAutomatons: url + 'EC_Automation/CurrOrgAutomations',
    triggerPointsList: url + 'EC_Automation/TriggerPointsList',
    automationEvents: url + 'EC_AutomationEvents',
    myAutomationEvents: url + 'EC_AutomationEvents/CurrOrg',
    automationEventsList: url + 'EC_AutomationEvents/CurrOrgEventsList',
    getCreditCampaigns: url + 'EC_Email_Campaigns/MyEmailCredits',
    postCreditCampaigns: url + 'EC_Email_Campaigns/CreditsRechargeFromWallet',
    emailsUsage: url + 'EC_Email_Campaigns/EmailsUsage',
    CampaignAccountantSMB: url + 'EC_Emails/AccountantSMBdataByType',
    bdOrgEntitiesCurrOrg: url + 'EC_Contacts/currOrg',
    contactsList: url + 'EC_Contacts',
    postBulkContacts: url + 'EC_Contacts/BulkContacts',
    getcontactsList: url + 'EC_Contacts/currOrg',

}

export const Organizationmgmt = {
    meetingMinutes: url + 'OM_Org_Meeting_Minutes',
    cuurentOrgMeetingMinutes: url + 'OM_Org_Meeting_Minutes/CurrOrgMeetingMinutes',
    cuurentOrgOmAttribute: url + 'OM_Org_Attributes/CurrOrgAttribute',
    OrgOmAttribute: url + 'OM_Org_Attributes',
    allAccountants: url + 'OM_Org_Attributes/AllAccountants',
    hierarchy: url + 'OM_Org_Hierarchy',
    hierarchyView: url + 'OM_Org_Hierarchy/HierarchyView',
    orgMembers: url + 'OM_Org_Members',
    currentOrgMembers: url + 'OM_Org_Members/HierarchyView',
    // orgContracts: url + 'OM_Org_Services',
    clientServices: url + 'OM_Org_Services/ClientServices',
    contracts: url + 'OM_Org_Contracts',
    myContracts: url + 'OM_Org_Contracts/MyContracts',
    // myContractCount: url + 'OM_Org_Contracts/mycontractscount',
    myGroupContracts: url + 'OM_Org_Contracts/MyGroupContracts',
    // myGroupContractCount: url + 'OM_Org_Contracts/groupcontractscount',
    allContracts: url + 'OM_Org_Contracts/AllContracts',
    // allContractCount: url + 'OM_Org_Contracts/allcontractsCount',
    // closedContractsCount: url + 'OM_Org_Contracts/ClosedContractsCount',
    qboaservice: url + 'OM_SP_Services',
    qboaCurrentService: url + 'OM_SP_Services/CurrOrgServices',
    qboaCustomers: url + 'OM_SP_Customers',
    currentQboaCustomers: url + 'OM_SP_Customers/CurrOrg',
    chatOrgs: url + 'OM_Chat/GetDropDownOrgs',
    currentOrgChat: url + 'OM_Chat/CurrOrg',
    allOrgs: url + 'OM_SP_Customers/AllOrgs',
    vendors: url + 'OM_SP_Customers/CurrOrgVendors',
    createCustomer: url + 'OM_SP_Customers/CreateOrganization',
    qboaCustomerMembers: url + 'OM_SP_Customers/OrgMembers',
    // accessRights: url + 'OM_Access_Rights',
    // curAccessRights: url + 'OM_Access_Rights/CurrOrg',

    servicePackage: url + 'OM_SP_Services/ServicePackagesByOrg',
    packageServicesByorg: url + 'OM_SP_Services/PackageServicesByOrg',
    packages: url + 'OM_SP_Services/packageservices',
    curPackages: url + 'OM_SP_Services/CurrOrgPackageServices',
    addcart: url + 'V_Service_Lines/ServiceCart',
    filling: url + 'OM_Org_Filing',
    filingHeaderLines: url + 'OM_Org_Filing/HeaderLines',
    existFormBank: url + 'OM_Org_Filing/fromBank',
    myFilings: url + 'OM_Org_Filing/MyFilings',
    myGroupFiling: url + 'OM_Org_Filing/MyGroupFilings',
    myallFiling: url + 'OM_Org_Filing/AllFilings',
    // filingById: url + 'OM_Org_Filing_Tasks/FilingId',
    filingTasks: url + 'OM_Org_Filing_Tasks',
    myFilingTasks: url + 'OM_Org_Filing_Tasks/MyFilingTasks/',
    // myFilingTaskCount: url + 'OM_Org_Filing_Tasks/myfilingtaskscount/',
    allFilingTasks: url + 'OM_Org_Filing_Tasks/AllFilingTasks/',
    // allFilingTaskCount: url + 'OM_Org_Filing_Tasks/allfilingtasksCount/',
    groupFilingTasks: url + 'OM_Org_Filing_Tasks/MyGroupFilingTasks/',
    // groupFolingTaskCount: url + 'OM_Org_Filing_Tasks/groupfilingtaskscount/',
    // closedFilingTaskCount: url + 'OM_Org_Filing_Tasks/ClosedFilingTasksCount/',
    bankListByappcode: url + 'OM_Services_Bank/BankList',//'V_Services_Bank/BankListByAppCode',
    serviceBankById: url + 'OM_Services_Bank',
    myAlerts: url + 'OM_Alert_Config/MyAlerts',
    alerts: url + 'OM_Alert_Config',
    clientFilling: url + 'OM_Org_Service_Filing/ClientFilings',
    myFilling: url + 'OM_Org_Service_Filing/MyFilings',
    assignedFilling: url + 'OM_Org_Service_Filing/AssignedFilings',
    filingRating: url + 'OM_Org_Service_Filing/Rating',
    contractFilling: url + 'OM_Org_Contracts/GetFilingsContractsById',
    cmnt: url + 'V_Services/AddComment',
    serProvider: url + 'OM_SP_Services/ByOSL_Id',
    qboaRequestservice: url + 'V_Services/ServiceRequest',
    getComments: url + 'V_Services/GetCommentsByOSL_Id',
    addMsg: url + 'OM_Chat',
    IncExp: url + 'OM_Org_Attributes/IncomeExpenseAccounts',
    omServiceBank: url + 'OM_Services_Bank',
    omServiceBankSteps: url + 'OM_Services_Bank/Steps',
    omserviceBankList: url + 'OM_Org_Service_Template/CurrOrgList',//'OM_Services_Bank/BankList',
    filingtemplatesData: url + 'OM_Org_Service_Template/CurrOrg',
    omFillingTemplatePOST: url + 'OM_Org_Service_Template',
    omFillingTemplateStepsT: url + 'OM_Org_Service_Template/Steps',
    a8UserCertificationBadges: url + 'V_User_Certification/BadgeList',
    a8UserCertification: url + 'V_User_Certification',
    a8UserCertificationHistory: url + 'V_User_Certification/History',
    a8UserCertificationHistoryPut: url + 'V_User_Certification/history',
    // putSettings: url + 'OM_App_Settings'
    // omsericeBank : url + 'OM_Services_Bank',
    // omsericeBanksteps: url + 'OM_Services_Bank/Steps',
}
export const Crm = {
    webLead: url + 'CRM_Web_Lead',
    webLeadCurrOrg: url + 'CRM_Web_Lead/CurrOrg',
    Opportunities: url + 'CRM_Opportunities',
    OppotCurrOrg: url + 'CRM_Opportunities/CurrOrg',
    oppotStages: url + 'CRM_Opportunity_Stage',
    opportunityList: url + 'CRM_Opportunity_Stage/List',
    opportunitiesList: url + 'CRM_Opportunities/CurrOrgList',
    leadSource: url + 'CRMLeadSource',
    leadSourceList: url + 'CRMLeadSource/CurrOrgList',
    leadSourceCurrOrg: url + 'CRMLeadSource/CurrOrg',
    salesPipeline: url + 'CRMSalesPipeline',
    salesPipelineList: url + 'CRMSalesPipeline/CurrOrgList',
    salesPipelineCurrOrg: url + 'CRMSalesPipeline/CurrOrg',
    templates: url + 'activitytemplates',
    templateCurrOrg: url + 'activitytemplates/CurrOrg',
    acSpServicesTemplateSteps: url + 'activitytemplates/Steps',
    acTemplateList: url + 'activitytemplates/CurrOrgList',
    jobcurOrgDropdown: url + 'CRM_SP_Jobs/CurrOrgJobsDropdown',
    acjobs: url + 'CRM_SP_Jobs',
    actasksDropdownByStaff: url + 'CRM_SP_Job_Tasks/tasksDropdownByStaff',
    acTaskBillingUpdate: url + 'CRM_SP_Job_Tasks/updateTaskBilling',
    acjobReview: url + 'CRM_SP_Jobs/CurrUserJobReviews',
    acUpdateMyJobReview: url + 'CRM_SP_Jobs/UpdateMyJobReview',
    acjobsName: url + 'CRM_SP_Jobs/name',
    acjobsapprover: url + 'CRM_SP_Jobs/approver',
    acjobsClientUpcomingJobs: url + 'CRM_SP_Jobs/ClientUpcomingJobs',
    acJobTaskActivities: url + 'CRM_SP_Jobs/JobTaskActivities',
    acjobsreviewer: url + 'CRM_SP_Jobs/reviewer',
    acjobTasksDashboardCounters: url + 'CRM_SP_Job_Tasks/DashboardCounters',
    apspJobTaskCurOrgApprovalList: url + 'CRM_SP_Job_Tasks/CurrOrgApproversList',
    acjobsDashboardCounters: url + 'CRM_SP_Jobs/DashboardCounters',
    acjobsbudgetHistory: url + 'CRM_SP_Jobs/budgetHistory',
    acTaskStatus: url + 'CRM_SP_Job_Tasks/status',
    acSubTaskStatus: url + 'CRM_SP_Job_Tasks/SubTaskStatus',
    acTaskDescription: url + 'CRM_SP_Job_Tasks/description',
    acTaskDropdownByJob: url + 'CRM_SP_Job_Tasks/tasksDropdownByJob',
    acsubTaskCopy: url + 'CRM_SP_Job_Tasks/CopyTask',
    acTaskAssignee: url + 'CRM_SP_Job_Tasks/staffAssignee',
    acTaskName: url + 'CRM_SP_Job_Tasks/name',
    acTaskBillingDetails: url + 'CRM_SP_Job_Tasks/TaskBillingDetails',
    acSubtaskFiles: url + 'CRM_SP_Job_Tasks/TaskFiles',
    actaskDependency: url + 'CRM_SP_Job_Tasks/taskDependancy',
    trashedJobs: url + 'CRM_SP_Jobs/trashedJobs',
    restoreJob: url + 'CRM_SP_Jobs/restore',
    acjobsBudget: url + 'CRM_SP_Jobs/budget',
    acTaskBudget: url + 'CRM_SP_Job_Tasks/taskBudget',
    acjobsStatus: url + 'CRM_SP_Jobs/status',
    acTaskDuedate: url + 'CRM_SP_Job_Tasks/dueDate',
    acTaskBillingRateByType: url + 'CRM_SP_Job_Tasks/billingRateByType',
    acjobsResource: url + 'CRM_SP_Jobs/resource',
    acWorkflowTags: url + 'CRM_SP_Jobs/myTags',
    acWorkflowTag: url + 'CRM_SP_Jobs/myTag',
    acJobTags: url + 'CRM_SP_Jobs/tags',
    acRemoveJobTags: url + 'CRM_SP_Jobs/jobTag',
    acJobsRemoveTag: url + 'CRM_SP_Jobs/removeTags',
    acJobsAddTag: url + 'CRM_SP_Jobs/Addtags',
    acJobsChangeStatus: url + 'CRM_SP_Jobs/changeStatus',
    acJobBulkDelete: url + 'CRM_SP_Jobs/deletebulkjobs',
    acSetupNotifications: url + 'CRM_SP_Setup/notificationsettings',
    acSetupnotificationsettingsByStaff: url + 'CRM_SP_Setup/notificationsettingsByStaff',
    acJobSaveAsTemplate: url + 'CRM_SP_Jobs/MakeJobSaveAsTemplate',
    acJobTag: url + 'CRM_SP_Jobs/tag',
    acStaffGroups: url + 'CRM_SP_Jobs/staffGroup',
    acTaskSubTasks: url + 'CRM_SP_Job_Tasks/subtask',
    acManyTasks: url + 'CRM_SP_Job_Tasks/ManyTasksStatus',
    acTaskBySubTasks: url + 'CRM_SP_Job_Tasks/SubTaksByTask',
    TrashedTasks: url + 'CRM_SP_Job_Tasks/trashedTasks',
    restoreTask: url + 'CRM_SP_Job_Tasks/restore',
    acJobFiles: url + 'CRM_SP_Jobs/JobFiles',
    acjobsFromTemplate: url + 'CRM_SP_Jobs/Jobfromtemplate',
    acJobscurOrg: url + 'CRM_SP_Jobs/CurrOrgJobs',
    acJobsLisat: url + 'CRM_SP_Jobs/CurrOrgJobsDropdown',
    acCustomerJobsList: url + 'CRM_SP_Jobs/CustomersJobsLists',
    acJobRecurringTypes: url + 'CRM_SP_Jobs/jobRecurringTypes',
    acJobTasks: url + 'CRM_SP_Job_Tasks',
    acJobTasksList: url + 'CRM_SP_Job_Tasks/ByJob',
    acJobTasksGet: url + 'CRM_SP_Job_Tasks/MyJobTasks',
    acJobCopy: url + 'CRM_SP_Jobs/CopyJob',
    jobTasksApprovals: url + 'CRM_SP_Job_Tasks/TaskApprovalByTask',
    approvals: url + 'CRM_SP_Job_Tasks/CurrUserTaskApprovals',
    approvalUpdate: url + 'CRM_SP_Job_Tasks/UpdateApproval',
    apSpJobTasks_AllJobtask: url + 'CRM_SP_Job_Tasks/AllJobTasks',
    apspJobTaskdropdown: url + 'CRM_SP_Job_Tasks/MyJobTasksDropdown',
    jobComments: url + 'CRM_SP_Comments',
    jobCommentsGet: url + 'CRM_SP_Comments/ByJob',
    jobTasksCommentsGet: url + 'CRM_SP_Comments/ByJobTask',
    acTeamByJob: url + 'CRM_SP_Jobs/TeamByJobCustomer',
    groups: url + 'CRM_Groups',
    deleteTeam: url + 'CRM_Group_Team',
    byStageGroups: url + 'CRM_Groups/crmgroupteam/{stageId}',
    currentOrgGroups: url + 'CRM_Groups/crmgroups',
    templateById: url + 'CRM_Templates',
    bdOrgEntities: url + 'CRM_Contacts',
    crmContactsTeamGroups: url + 'CRM_Contacts/ContactGroups',
    accountantClients: url + 'CRM_Contacts/AccountantClients',
    cbTeamByCustomer: url + 'CRM_Contacts/groupTeamListByCustomer',
    bdOrgEntitiesCurrOrg: url + 'CRM_Contacts/currOrg',
    cbCustTeambyCustomer: url + 'CRM_Contacts/groupTeamByCustomer',
    cbAssignTeamCustomer: url + 'CRM_Contacts/assignGroups',
    customersByGroup: url + 'CRM_Contacts/CustomersByGroup',
    crmContactsCurrOrg: url + 'CRM_Contacts/CRMcontactsopportunitieslist',
    crmMakeCustomer: url + 'CRM_Contacts/makeCustomer',
    bdOrgEntitiesCurrOrgList: url + 'BD_Org_Entities/currOrgList',
    createClientInQBO: url + 'BD_Org_Entities/createQBOCustomer',
    createClientInFBO: url + 'BD_Org_Entities/createFBOCustomer',
    createClientInQXER: url + 'BD_Org_Entities/createXeroCustomer',
    contactOpportunityList: url + 'BD_Org_Entities/OrgEntitiesOpportunitiesList',
    // oppCurrOrgList: url + 'CRM_Opportunities/CurrOrgList',
    templateCurrOrgList: url + 'CRM_Templates/CurrOrgList',
    // usergroupcurrOrg: url + 'V_User_Groups/currOrgGroupTeam',
    // usergroupList: url + 'V_User_Groups/GroupsList',
    templateBanklist: url + 'CRM_Template_Bank/BankList',
    comments: url + 'CRM_Comments',
    lineComments: url + 'CRM_Comments/linecomments',
    commentsByid: url + 'CRM_Comments/comments',
    alerts: url + 'CRM_Alert_Config',
    crmActivityAlerts: url + 'CRM_Alert_Config/ByActivity',
    crmActivityLinesAlerts: url + 'CRM_Alert_Config/ByActivityline',
    estimate: url + 'QBEstimate',
    estimateCurrent: url + 'QBEstimate/CurrOrg',
    clientIssuesUrl: url + 'CRM_Issues',
    clientIssues: url + 'CRM_Issues/CurrOrgIssues',
    clientIssuesList: url + 'CRM_Issues/CurrOrgIssuesList',
    activityTasksTimer: url + 'CRM_Timer',
    activityTasksTimersGet: url + 'CRM_Timer/CurrOrgTimers',
    activityHistory: url + 'CRM_Contacts/currOrgActHistory',
    activitydropdown: url + 'CRM_Activities/ActivitiesList'
}

// Document Management
export const DMUrls = {
    myDrive: url + 'FilesAttachement/Drive',
    myfiles: url + 'FilesAttachement/myimages',
    myDrivetree: url + 'FilesAttachement/DriveTree',
    editorFileload: url + 'FilesAttachement/editorFileUpload',
    quillFileload: url + 'FilesAttachement/quillFileUpload',
    editorGetLink: url + 'FilesAttachement/editorLink',
    entityfolders: url + 'FilesAttachement/ByUserType',
    cbworkspaceByBFEMId: url + 'FilesAttachement/AccountingWorkspace/',
    folderCreate: url + 'FilesAttachement/Folder/Create',
    folderById: url + 'FilesAttachement/Folder',
    fileUpload: url + 'FilesAttachement/File/Upload',
    clientFileUpload: url + 'FilesAttachement/File/clientUpload',
    fileDelete: url + 'FilesAttachement/File/Delete',
    share: url + 'FilesAttachement/Share',
    moveTo: url + 'FilesAttachement/FolderOrFile/Move',
    copyByID: url + 'FilesAttachement/File_Copy',
    rename: url + 'FilesAttachement/Rename',
    remove: url + 'FilesAttachement/File/Delete',
    removeFromStarred: url + 'FilesAttachement/File/RemoveStarred', // /{id}?type=FILE
    addToStared: url + 'FilesAttachement/File/Stared', // /{id}?type=FILE (or) type=FOLDER
    viewDetails: url + 'FilesAttachement/viewdetails', // /444?type=FILE (or) type=FOLDER
    openUpdate: url + 'FilesAttachement/File/updateopendate',
    starredGet: url + 'FilesAttachement/File/Stared',
    recentGet: url + 'FilesAttachement/File/Recent',
    accesss: url + 'FilesAttachement/Access',
    fileStorageUsage: url + 'FilesAttachement/CurrOrgFileStorage',
    dmfolderClientAccess: url + 'FilesAttachement/Folder/ClientAccess/',
    shareGet: url + 'FilesAttachement/File/Share',
    sendLinkEmail: url + 'EC_Emails/SendEmail',
    googleFilesList: url + 'Google/FilesList',
    googleoAuthUrl: url + 'Google/OAuthUrl',
    googleCallBack: url + 'Google/CallBack',
    googleCreateFolder: url + 'Google/CreateFolder',
    googleUploadFile: url + 'Google/UploadFile',
    googleFileDownload: url + 'Google/FileDownload',
    googleFileView: url + 'Google/ViewLink',
    googleFolderFiles: url + 'Google/FilesByFolder',
    googleCalendarEvents: url + 'Google/CalendarEventList',
    googleCalendarColorsEvents: url + 'Google/CalendarColorsList',
    googleCreateEvent: url + 'Google/CreateEvent',
    googleUpdateEvent: url + 'Google/UpdateEvent',
    googleMailData: url + 'Google/GMailMessagesList',
    googleAccountDisconnect: url + 'Google/Disconnect',
    googleClassroomCourses: url + 'Google/ClassroomCourses',
    googleClassRoomCourseById: url + 'Google/ClassroomCourseById',
    googleTeacherAddCourses: url + 'Google/AddCourseTeachersToRoom',
    googleStudentAddCourses: url + 'Google/AddCourseStudentsToRoom',
    googleAddCourses: url + 'Google/AddCourseStudentsToRoom',
    makeAsCoAssistant: url + 'KS_AI_Rooms/MakeCoAssistant',
    orgIntegration: url + 'OrgIntegration',
    storageSummary: url + 'V_Contact/StorageSummary',
    emailsSummary: url + 'V_Contact/EmailsSummary',
    Drive_ClientWorkMap: url + 'DM_Drive_Map'
}
//Projects
export const Projects = {
    pmjobs: url + 'PM_Jobs',
    pmJobCopy: url + 'PM_Jobs/CopyJob',
    pmJobscurOrg: url + 'PM_Jobs/CurrOrgJobs',
    templates: url + 'PM_Services_Template',
    pmTemplateList: url + 'PM_Services_Template/CurrOrgList',
    jobMileStone: url + 'PM_Milestones',
    jobMileStoneGet: url + 'PM_Milestones/ByJob',
    jobcurOrgDropdown: url + 'PM_Jobs/CurrOrgJobsDropdown',
    pmJobTasks: url + 'PM_Job_Task',
    pmJobTasksGet: url + 'PM_Job_Task/MyJobTasks',
    allJobtask: url + 'PM_Job_Task/AllJobTasks',
    apspJobTaskCurOrgApprovalList: url + 'PM_Job_Task/CurrOrgApproversList',
    apspJobTaskdropdown: url + 'PM_Job_Task/MyJobTasksDropdown',
    jobTasksIssues: url + 'PM_Task_Issue',
    jobTasksIssuesGet: url + 'PM_Task_Issue/ByJobTask',
    jobTasksApprovals: url + 'PM_Job_Task/TaskApprovalByTask',
    approvals: url + 'PM_Job_Task/CurrUserTaskApprovals',
    approvalUpdate: url + 'PM_Job_Task/UpdateApproval',
    templateCurrOrg: url + 'PM_Services_Template/CurrOrg',
    pmSpServicesTemplateSteps: url + 'PM_Services_Template/Steps',
    jobAlerts: url + 'AC_SP_Alert_Config',
    jobAlertsGet: url + 'AC_SP_Alert_Config/ByJob',
}

// Accountant
export const Accountant = {
    erMyAppEmails: url + 'ER_App_Email_Content/MyAppEmails',
    erAppEmailsContent: url + 'ER_App_Email_Content/AppEmail',
    ErAppEmailContent: url + 'ER_App_Email_Content',
    alertConfig: url + 'AC_SP_Alert_Config',
    acCustomers: url + 'AC_SP_Customers',
    TimeReportsSummary: url + 'AC_SP_Reports/Staff/TimeReportsSummary',
    TimeReportsDetailed: url + 'AC_SP_Reports/Staff/TimeReportsDetailed',
    ClientTaskFilesByDate: url + 'AC_SP_Reports/Staff/ClientTaskFilesByDate',
    TeamActivityByDate: url + 'AC_SP_Reports/Staff/TeamActivityByDate',
    acCustomersByGroup: url + 'AC_SP_Customers/ClientsByGroup',
    assignGroupsToClient: url + 'AC_SP_Customers/assignGroups',
    acContracts: url + 'AC_SP_Job_Contracts',
    apspJobTaskCurOrgApprovalList: url + 'AC_SP_Job_Tasks/CurrOrgApproversList',
    acspCustTeambyCustomer: url + 'AC_SP_Customers/TeamByCustomer',
    acMyContracts: url + 'AC_SP_Job_Contracts/MyContracts',
    acPBCList: url + 'AC_SP_PBC_List',
    acPBCListView: url + 'AC_SP_PBC_List/View',
    acPBCListLine: url + 'AC_SP_PBC_List/Line',
    acMyPBCLists: url + 'AC_SP_PBC_List/MyPBCLists',
    acPBCListsByClient: url + 'AC_SP_PBC_List/ByClient',
    acStaffSchedule: url + 'AC_SP_Staff_Scheduling',
    acStaffScheduleSlot: url + 'AC_SP_Staff_Scheduling/slot',
    acStaffScheduleByStaff: url + 'AC_SP_Staff_Scheduling/ByStaffOrTask',
    acClientTaskReport: url + 'AC_SP_Reports/Clients/ClientTasks',
    acInterfaceInvoice: url + 'AC_SP_Reports/Billing/InterfaceInvoices',
    acQBOReceivables: url + 'AC_SP_Reports/Billing/Receivables',
    acClientPortals: url + 'AC_SP_Reports/Clients/ClientPortals',
    acHoursTrackedbyClient: url + 'AC_SP_Reports/Clients/HoursTrackedByClient',
    acHoursTrackedbyService: url + 'AC_SP_Reports/Clients/HoursTrackedByService',
    acClientPendingTasks: url + 'AC_SP_Reports/Staff/ClientPendingTasks',
    acCapacityManagement: url + 'AC_SP_Reports/Productivity/CapacityManagement',
    acProductivityByStaff: url + 'AC_SP_Reports/Productivity/ProductivityByStaff',
    acProductivityJobProposal: url + 'AC_SP_Reports/Productivity/JobProposals',
    bdOrgEntityGroupscontactMapSubmit: url + 'BD_Org_Entity_Groups/assignContacts',
    jobcurOrgDropdown: url + 'AC_SP_Jobs/CurrOrgJobsDropdown',
    acjobs: url + 'AC_SP_Jobs',
    actasksDropdownByStaff: url + 'AC_SP_Job_Tasks/tasksDropdownByStaff',
    acTaskBillingUpdate: url + 'AC_SP_Job_Tasks/updateTaskBilling',
    acjobReview: url + 'AC_SP_Jobs/CurrUserJobReviews',
    acUpdateMyJobReview: url + 'AC_SP_Jobs/UpdateMyJobReview',
    acjobsName: url + 'AC_SP_Jobs/name',
    acjobsapprover: url + 'AC_SP_Jobs/approver',
    acjobsClientUpcomingJobs: url + 'AC_SP_Jobs/ClientUpcomingJobs',
    acJobTaskActivities: url + 'AC_SP_Jobs/JobTaskActivities',
    acjobsreviewer: url + 'AC_SP_Jobs/reviewer',
    acjobTasksDashboardCounters: url + 'AC_SP_Job_Tasks/DashboardCounters',
    acjobsDashboardCounters: url + 'AC_SP_Jobs/DashboardCounters',
    acjobsbudgetHistory: url + 'AC_SP_Jobs/budgetHistory',
    acTaskStatus: url + 'AC_SP_Job_Tasks/status',
    acSubTaskStatus: url + 'AC_SP_Job_Tasks/SubTaskStatus',
    acTaskDescription: url + 'AC_SP_Job_Tasks/description',
    acTaskDropdownByJob: url + 'AC_SP_Job_Tasks/tasksDropdownByJob',
    acsubTaskCopy: url + 'AC_SP_Job_Tasks/CopyTask',
    acTaskAssignee: url + 'AC_SP_Job_Tasks/staffAssignee',
    acTaskName: url + 'AC_SP_Job_Tasks/name',
    acTaskBillingDetails: url + 'AC_SP_Job_Tasks/TaskBillingDetails',
    acSubtaskFiles: url + 'AC_SP_Job_Tasks/TaskFiles',
    actaskDependency: url + 'AC_SP_Job_Tasks/taskDependancy',
    trashedJobs: url + 'AC_SP_Jobs/trashedJobs',
    restoreJob: url + 'AC_SP_Jobs/restore',
    acjobsBudget: url + 'AC_SP_Jobs/budget',
    acTaskBudget: url + 'AC_SP_Job_Tasks/taskBudget',
    acjobsStatus: url + 'AC_SP_Jobs/status',
    acTaskDuedate: url + 'AC_SP_Job_Tasks/dueDate',
    acTaskBillingRateByType: url + 'AC_SP_Job_Tasks/billingRateByType',
    acjobsResource: url + 'AC_SP_Jobs/resource',
    acWorkflowTags: url + 'AC_SP_Jobs/myTags',
    acWorkflowTag: url + 'AC_SP_Jobs/myTag',
    acJobTags: url + 'AC_SP_Jobs/tags',
    acRemoveJobTags: url + 'AC_SP_Jobs/jobTag',
    acJobsRemoveTag: url + 'AC_SP_Jobs/removeTags',
    acJobsAddTag: url + 'AC_SP_Jobs/Addtags',
    acJobsChangeStatus: url + 'AC_SP_Jobs/changeStatus',
    acJobBulkDelete: url + 'AC_SP_Jobs/deletebulkjobs',
    acSetupNotifications: url + 'AC_SP_Setup/notificationsettings',
    acSetupnotificationsettingsByStaff: url + 'AC_SP_Setup/notificationsettingsByStaff',
    acJobSaveAsTemplate: url + 'AC_SP_Jobs/MakeJobSaveAsTemplate',
    acJobTag: url + 'AC_SP_Jobs/tag',
    acStaffGroups: url + 'AC_SP_Jobs/staffGroup',
    acTaskSubTasks: url + 'AC_SP_Job_Tasks/subtask',
    acManyTasks: url + 'AC_SP_Job_Tasks/ManyTasksStatus',
    acTaskBySubTasks: url + 'AC_SP_Job_Tasks/SubTaksByTask',
    TrashedTasks: url + 'AC_SP_Job_Tasks/trashedTasks',
    restoreTask: url + 'AC_SP_Job_Tasks/restore',
    acJobFiles: url + 'AC_SP_Jobs/JobFiles',
    acjobsFromTemplate: url + 'AC_SP_Jobs/Jobfromtemplate',
    acJobscurOrg: url + 'AC_SP_Jobs/CurrOrgJobs',
    acJobsLisat: url + 'AC_SP_Jobs/CurrOrgJobsDropdown',
    acCustomerJobsList: url + 'AC_SP_Jobs/CustomersJobsLists',
    acJobRecurringTypes: url + 'AC_SP_Jobs/jobRecurringTypes',
    acJobTasks: url + 'AC_SP_Job_Tasks',
    acJobTasksList: url + 'AC_SP_Job_Tasks/ByJob',
    acJobTasksGet: url + 'AC_SP_Job_Tasks/MyJobTasks',
    acJobCopy: url + 'AC_SP_Jobs/CopyJob',
    jobTasksApprovals: url + 'AC_SP_Job_Tasks/TaskApprovalByTask',
    approvals: url + 'AC_SP_Job_Tasks/CurrUserTaskApprovals',
    approvalUpdate: url + 'AC_SP_Job_Tasks/UpdateApproval',
    apSpJobTasks_AllJobtask: url + 'AC_SP_Job_Tasks/AllJobTasks',
    getJobTasksByJob: url + 'AC_SP_Job_Tasks/JobTasksByJob',
    apspJobTaskdropdown: url + 'AC_SP_Job_Tasks/MyJobTasksDropdown',
    acTeamByJob: url + 'AC_SP_Jobs/TeamByJobCustomer',
    jobComments: url + 'AC_SP_Comments',
    jobCommentsGet: url + 'AC_SP_Comments/ByJob', // AC_SP_Comments/ByJob/{jobId}
    jobTasksCommentsGet: url + 'AC_SP_Comments/ByJobTask',
    pBCComments: url + 'AC_SP_PBC_Comments',
    pBCCommentsByPBCList: url + 'AC_SP_PBC_Comments/PBCList/',
    acClientTask: url + 'AC_SP_ClientTasks',
    acClientTaskAttachments: url + 'AC_SP_ClientTasks/addAttachments',
    acUpdateClientTaskName: url + 'AC_SP_ClientTasks/taskname',
    acClientTaskNotes: url + 'AC_SP_ClientTasks/updateNotes',
    acClientTaskDelete: url + 'AC_SP_ClientTasks/task',
    acClientTaskReminberbyJob: url + 'AC_SP_ClientTasks/reminberbyJob',
    acClientTaskupdateForm: url + 'AC_SP_ClientTasks/updateForm',
    acClientuploadSettings: url + 'AC_SP_ClientTasks/uploadSettings',
    acClientTaskreminderSettings: url + 'AC_SP_ClientTasks/reminderSettings',
    acCurrorgClientTasks: url + 'AC_SP_ClientTasks/currorgclienttasks',
    acProposalComments: url + 'AC_SP_Proposal_Comments',
    acClientTaskUpdateDueDate: url + 'AC_SP_ClientTasks/updateDueDate',
    acClientTaskStatus: url + 'AC_SP_ClientTasks/clientTaskStatus',
    acClientUploadsDisable: url + 'AC_SP_ClientTasks/disableClientUploads',
    acjobsClientTaskscomments: url + 'AC_SP_ClientTasks/comments',
    acjobsClientTaskscomment: url + 'AC_SP_ClientTasks/comment',
    acClientTasksreminderContacts: url + 'AC_SP_ClientTasks/reminderContacts',
    acjobsClientTaskssignatureEnable: url + 'AC_SP_ClientTasks/signatureEnable',
    acjobsclienttasksbyJob: url + 'AC_SP_ClientTasks/clienttasksbyJob',
    acCommentsByProposal: url + 'AC_SP_Proposal_Comments/Proposal/',
    acProposalreminderContacts: url + 'AC_SP_Proposal_Reminders/reminderContacts',
    acSignaturesByProposal: url + 'AC_SP_Signature_Map/ByProposal',
    cbSignaturePost: url + 'AC_SP_Signature_Map/signature',
    selectedOptions: url + 'AC_SP_Proposal/SelectedOptions',
    selectOptions: url + 'AC_SP_Proposal/SelectOptions',
    submitProposal: url + 'AC_SP_Proposal/SignProposal',
    prSetupNotifications: url + 'AC_SP_Proposal_Setup/notificationsettings',
    prSetupnotificationsettingsByStaff: url + 'AC_SP_Proposal_Setup/notificationsettingsByStaff',
    askSignatureFromCA: url + 'AC_SP_Signature_Map',
    addSignatureFromCA: url + 'AC_SP_Signature_Map/AddSignature',
    jobMileStone: url + 'AC_SP_Milestones',
    jobMileStoneGet: url + 'AC_SP_Milestones/ByJob',
    jobRetainer: url + 'AC_SP_Retainer',
    jobRetainerPayment: url + 'AC_SP_Retainer/ByPayment',
    jobRetainerGet: url + 'AC_SP_Retainer/ByJob',
    // jobContracts: url + 'AC_SP_Job_Contracts',
    jobContractsGet: url + 'AC_SP_Job_Contracts/ByJob',
    jobExpenses: url + 'AC_SP_Expenses',
    jobExpensesGet: url + 'AC_SP_Expenses/ByJobTask',
    jobAlerts: url + 'AC_SP_Alert_Config',
    jobAlertsGet: url + 'AC_SP_Alert_Config/ByJob',
    staff: url + 'AC_SP_Staff_Performance',
    staffGet: url + 'AC_SP_Staff_Performance/CurrOrg',
    staffLocation: url + 'AC_SP_Firm_Staff_Location',
    staffLocationGet: url + 'AC_SP_Firm_Staff_Location/CurrOrg',
    // acCustCurOrgDropdown: url + 'AC_SP_Customers/CurrOrgCustomersDropdown',
    bdOrgEntitesCurOrgCustomers: url + 'BD_Org_Entities/CurrOrgList',
    bdOrgEntitesAccountant8JobPost: url + 'BD_Org_Entities/Accountant8JobsData',
    mybdOrgEntitiesGroups: url + 'BD_Org_Entity_Groups/MyClientGroups',
    clientGroups: url + 'BD_Org_Entity_Groups/group',
    bdOrgEntitiesGroups: url + 'BD_Org_Entity_Groups/ClientGroups',
    bdOrgEntitiesGroup: url + 'BD_Org_Entity_Groups/ClientGroup',
    bdOrgEntityGroupsList: url + 'BD_Org_Entity_Groups/MyClientGroupsList',
    bdOrgEntityGroupsMapList: url + 'BD_Org_Entity_Groups/CurrOrgContactsMapList',
    bdOrgEntityGroupsMapSubmit: url + 'BD_Org_Entity_Groups/assignClients',
    bdOrgEntites: url + 'BD_Org_Entities',
    bdOrgEntitesUpdate: url + 'BD_Org_Entities/clientUpdate',
    bdOrgEntityContacts: url + 'BDOEM_Contact',
    bdProspectClient: url + 'BD_Prospect_Clients',
    bdProspectClientApproval: url + 'BD_Prospect_Clients/approve',
    jobTasksIssues: url + 'AC_SP_Task_Issues',
    jobTasksIssuesGet: url + 'AC_SP_Task_Issues/MyIssues',
    jobTasksAlertsGet: url + 'AC_SP_Alert_Config/ByJobTask',
    jobTaskTimer: url + 'AC_SP_Timer',
    jobTaskTimerGet: url + 'AC_SP_Timer/ByJobTask',
    jobTaskTimeSheetGet: url + 'AC_SP_Timesheets/ByJobTask',
    staffBillingRatesPost: url + 'AC_SP_Client_BillingRate',
    staffBillingRates: url + 'AC_SP_Client_BillingRate/CurrOrg',
    timerRange: url + 'AC_SP_Timer/ByJobTaskAndDateRange',
    timeractiveStatus: url + 'AC_SP_Timer/activeStatus',
    unprocessTimerFromTimesheet: url + 'AC_SP_Timer/UnprocessTimer',
    timeSheet: url + 'AC_SP_Timesheets',
    timeSheetByTimer: url + 'AC_SP_Timesheets/FromTimers',
    alertByIssue: url + 'AC_SP_Alert_Config/ByIssue',
    payments: url + 'AC_SP_Payments',
    addRetainerInLines: url + 'AC_SP_Payments/AddRetainerInLines',
    paymentsMultiple: url + 'AC_SP_Payments/multiple',
    paymentsGet: url + 'AC_SP_Payments/ByCustomer',
    getRETCategoryAndDateRange: url + 'AC_SP_Payments/GetRETCategoryAndDateRange',
    aC_SP_Payments: url + 'AC_SP_Payments/paymentMethod',
    paymentsGetByExpense: url + 'AC_SP_Expenses/ExpensesByTaskAndDateRange',
    paymentsGetByTimeSheet: url + 'AC_SP_Timesheets/TimesheetsByTaskAndDateRange',
    paymentsGetByRetainer: url + 'AC_SP_Retainer/RetainersByJobAndDateRange',

    pBCtemplateCurrOrg: url + 'AC_SP_PBC_Templates/CurrOrg',
    acPBCTemplates: url + 'AC_SP_PBC_Templates',
    acPBCTemplatesPatch: url + 'AC_SP_PBC_Templates/TemplateToPBC',
    acPBCTemplatesList: url + 'AC_SP_PBC_Templates/CurrOrgList',
    templateBanklist: url + 'V_Services_Bank/BankListByAppCode',
    templateBankById: url + 'V_Services_Bank/ACApp',
    bdOrgEntitiesQBGet: url + 'BD_Org_Entities/QBGet',
    orgInvoicesStatusUpdate: url + 'BD_Org_Entities/invoiceStatusUpdate',
    VendorsQBGet: url + 'BD_Org_Entities/VendorsGet',
    acServiceBank: url + 'AC_Services_Bank',
    acTemplatesLibrary: url + 'AC_Services_Bank/GetTemplatesLibrary',
    AddToTemplatesFromLibrary: url + 'AC_Services_Bank/AddToTemplate',
    acServiceBankSteps: url + 'AC_Services_Bank/Steps',
    acserviceBankList: url + 'AC_Services_Bank/BankList',
    AcspTimerMyTimer: url + 'AC_SP_Timer/MyTimers',
    AcspTimerActiveTimers: url + 'AC_SP_Timer/ActiveTimers',
    AcspTimerCurrOrgTimer: url + 'AC_SP_Timer/CurrOrgTimers',
    templates: url + 'jobtemplates',
    templateCurrOrg: url + 'jobtemplates/CurrOrg',
    acSpServicesTemplateSteps: url + 'jobtemplates/Steps',
    acTemplateList: url + 'jobtemplates/CurrOrgList',
    acPbcListsLine: url + 'AC_SP_PBC_List/Line',
    acPbcListsLineReply: url + 'AC_SP_PBC_List/ClientSubmit',
    acSpTimerByLMJobTask: url + 'AC_SP_Timer/ByLMJobTask',
    currOrgItemsList: url + 'QBItems/CurrOrgList',
    acProposalServices: url + 'AC_Services',
    acProposalPackages: url + 'AC_PT_ServicePackage',
    acProposalServicesList: url + 'AC_Services/CurrOrgList',
    acProposalTermsList: url + 'AC_SP_Terms/List',
    acProposalBlocks: url + 'AC_SP_Proposal_Content',
    acterms: url + 'AC_SP_Terms',
    actermsList: url + 'AC_SP_Terms/List',
    actermsClientMap: url + 'AC_TermsClientMap',
    actermsClientMapData: url + 'AC_TermsClientMap/list',
    acProposal: url + 'AC_SP_Proposal',
    acMyProposal: url + 'AC_SP_Proposal/MyPoposals',
    acProposalList: url + 'AC_SP_Proposal/CurrOrgPoposalsDropdown',
    acProposalByLink: url + 'AC_SP_Proposal/ByLink',
    proposalCreateJob: url + 'AC_SP_Proposal/createJob',
    acProposals: url + 'AC_SP_Proposal/MyPoposals',
    acProposalsByClient: url + 'AC_SP_Proposal/ByClient',
    acProposalsByProposal: url + 'AC_SP_Proposal_Reminders/ByProposal',
    acSpServices: url + 'AC_Services/CurrOrg',
    acSpServicesList: url + 'AC_Services/CurrOrgList',
    proposalActivities: url + 'AC_SP_Proposal/proposalActivities',
    proposalReminders: url + 'AC_SP_Proposal_Reminders',
    acproposalActiveInactiveNotifications: url + 'AC_SP_Proposal_Reminders/ActiveInactiveNotifications',
    acProposalCopy: url + 'AC_SP_Proposal/CopyProposal',
    acPackages: url + 'AC_PT_ServicePackage/CurrOrgServicePackages',
    acPackagesList: url + 'AC_PT_ServicePackage/ServicePackagesList',
    acPricingToolNameRoute: url + 'AC_PT_Names',
    acPricingToolByLink: url + 'AC_PT_Names/ByLink',
    postPricingMapping: url + 'AC_PT_Names/ToolLines',
    getToolDefaultValues: url + 'AC_PT_Names/GetToolDefaultValues',
    updateToolDefaultValues: url + 'AC_PT_Names/ToolDefaultValues',
    postSinglePricingMapping: url + 'AC_PT_Names/ToolLine',
    acPricingToolName: url + 'AC_PT_Names/CurrOrgPricingTools',
    acPricingToolTree: url + 'AC_PT_Names/PricingTools',
    acPricingToolVariblet: url + 'AC_PT_Variable',
    acPricingToolVaribleDelete: url + 'AC_PT_Variable/line',
    acPricingToolVariblePriceList: url + 'AC_PT_Variable/VariableFeeList',
    acPricingToolVariblePriceListById: url + 'AC_PT_Variable/VariableFeebyId',
    acPricingToolRolePrice: url + 'AC_PT_Role',
    acPricingToolRolePriceDataList: url + 'AC_PT_Role/ServiceFeeList',
    acPricingToolRolePriceList: url + 'AC_PT_Role/CurrOrgServiceRoleFees',



    acPricingGroupData: url + 'AC_PricingToolClientGroup/CurrOrgClientsList',
    acPricingClientGroup: url + 'AC_PricingToolClientGroup/ClientGroup',
    acPricingClientGroupMap: url + 'AC_PricingToolClientGroup',
    acPricingToolAssign: url + 'AC_PricingToolClientGroup/assignTool',
    acpriceBookOutput: url + 'AC_PT_Output',
    acpriceBookOutputByLink: url + 'AC_PT_Output/ByLink',
    acPricingBookAssignTOClients: url + 'AC_PricingToolClientGroup/assignClients',
    clientsByPricingBook: url + 'AC_PricingToolClientGroup/CurrOrgClientsByBook',
    cAPushClient: url + 'BD_Org_Entities/pushClient',
    bdOrgEntitesAccountant8JobGet: url + 'BD_Org_Entities/GetAccountant8JobsData',
    ClientVault: url + 'NH_ClientVault',
    ClientVaultByClient: url + 'NH_ClientVault/ByClient',
    ClientVaultaccessUsers: url + 'NH_ClientVault/accessUsers',
}

export const BA_Advisor = {
    userProfile: url + "BA_Advisor/PersonalProfile",
    beAdvisor: url + "BA_Advisor",
    findAdvisor: url + "BA_Advisor/SearchAdvisor?",
    adviorDetails: url + "BA_Advisor/Advisor/ByuserId/",
    activityPost: url + "BA_Adv_Activity",
    myactivities: url + "BA_Adv_Activity/MyActivities?pageindex=1&pagesize=15",
    ProposedActivities: url + "BA_Adv_Activity/ProposedActivities?pageindex=1&pagesize=15",
    getactivityLines: url + "BA_Adv_Activity_Lines/ByActivity/",
    postChatLines: url + "BA_Adv_Activity_Lines",
    paymentsGet: url + "BA_Payments?",
    addToCart: url + "BA_Payments/AddToCart",
    ratingUrl: url + "BA_Adv_Rating",
    postPayment: url + "BA_Payments/",
    pushInvoiceEntities: url + "BD_Org_Entities/PushInvoice"

    //updateActivity:url+"BA_Adv_Activity",
}

// job
export const Job = {
    jobs: url + 'JS_Jobs',
    jsJobsforCA: url + 'JS_Jobs/forca',
    jobProposal: url + 'JS_Job_Proposals',
    jobSearch: url + 'JS_Jobs/SearchJobs',
    jobAccountant: url + 'JS_Jobs/SearchAccountant',
    SavedJobs: url + 'JS_SP_Saved_Jobs',
    savedCA: url + 'JS_Saved_CA ',
    jobsCurrOrg: url + 'JS_Jobs/CurrOrgJobs',
    jSpSavedJobs: url + 'JS_SP_Saved_Jobs/savedjobs',
    jsSpSavedJobsRemove: url + 'JS_SP_Saved_Jobs/remove',
    jsSavedCA: url + 'JS_Saved_CA/savedcas',
    jsSavedRemove: url + 'JS_Saved_CA/remove',
    jsJobProposalsCuurCA: url + 'JS_Job_Proposals/Currca',
    jsJobProposalsCuurCB: url + 'JS_Job_Proposals/Currcb',
    AccountantSee: url + 'JS_Job_Proposals/93abae79-bee2-45c9-8c05-05b9b5170680',
    jobsCurrOrgJobsDropdown: url + 'JS_Jobs/CurrOrgJobsDropdown',
    vUserProfile: 'V_User_Profile/AccUserProfile',
    jobInvites: url + 'JS_Job_Invites',
    jonInvitesCA: url + 'JS_Job_Invites/InvitedCA',
    jonInvitesCB: url + 'JS_Job_Invites/Invited',
    userProfileByUser: url + 'JS_Jobs/CAUserProfileByUser',
    jsChatCB: url + 'JS_Chat/getcb',
    jsChatCA: url + 'JS_Chat/getca',
    jsChat: url + 'JS_Chat',
    jschatChat: url + 'JS_Chat/Chat',
    jsJobsCurrOrgCADropdown: url + 'JS_Jobs/CurrOrgCADropdown',
    jsSpCustRating: url + 'JS_SP_Cust_Rating',
    jsjobProposalStatus: url + 'JS_Job_Proposals/Status',
    jsJobsUpdate: url + 'JS_Jobs/update',
    jsJobsGetJob: url + 'JS_Jobs/getjob',
    jsChatProposedJobsDropdown: url + 'JS_Chat/ProposedJobsDropdown',
    jsJobsForAdvisor: url + 'JS_Jobs/GetJobs',
    jsJobsMatchedAccountant: url + 'JS_Jobs/matchedAccountants',
    jsJobsMatchJobs: url + 'JS_Jobs/matchedJobs',
    jsJobsClose: url + 'JS_Jobs/close',
    jsJobsDraft: url + 'JS_Jobs/Draft',
    acSpPaymentsCustomerPayments: url + 'AC_SP_Payments/CustomerPayments',
    acSpPayments: url + 'AC_SP_Payments/AddToCart',
}

export const VcPortal = {
    customersList: url + 'VCPortal/MyCustomers?',
    vendorsList: url + 'VCPortal/MyVendors?',
    invitationsList: url + 'VCPortal/MyVCInvitationsLog?',
    postEditEmail: url + 'VCPortal/UpdateEntity/',
    sendInviteURL: url + 'VCPortal/Invite',
    sendAccountantInviteURL: url + 'VCPortal/InviteAccountant',
    pendingVerifications: url + 'VCPortal/GetPendingVerifications',
    updateVerification: url + 'VCPortal/CACBVerify/',
    getAccountantByBFEMId: url + 'VCPortal/VendorById/',
    advisorData: url + 'Portal_ProAdvisor/ProAdvisors?',
    postUrl: url + 'Portal_ProAdvisor/Advisor',
    getProAdvisorsData: url + 'Portal_ProAdvisor/ProAdvisorsDataEntry',
    sendProInvite: url + 'Portal_ProAdvisor/AdvisorActivity',
    activityUrl: url + 'Portal_ProAdvisor/ActivitiesByAdvisor',
    bdOrgEntitiesEntity: url + 'BD_Org_Entities/Entity',
    cbActivities: url + 'VCPortal/CBActivities',

}
export const ToDoList = {
    toDoListUrl: url + 'TeamToDo/MyToDos?',
    teamList: url + 'V_User_Groups/CurrentOrgTeam',
    teamAdminsList: url + 'V_User_Groups/CurrentOrgTeamAdmins',
    clientTeamList: url + 'V_User_Groups/ClientTeam',
    postTask: url + 'TeamToDo',
    deleteTask: url + 'TeamToDo/',
    getCalendarData: url + 'TeamToDo/CalendarData',
    addEvent: url + 'TeamToDo/Calendar/AddEvent'
}

export const FixUncat = {
    getClientSettingById: url + 'FU_AS_ClientSettings',
    getClientSettingActive: url + 'FU_AS_ClientSettings/Active',
    getSettingsByAccSW: url + 'FU_AS_ClientSettings/clientSettingsBankByAccSW',
    getClientSettingsByBFEMId: url + 'FU_AS_ClientSettings/SettingsByCBOrgId',
    syncTrxByCategory: url + 'FU_AS_ClientSettings/syncUncatTrxByCatFromQBO',
    getCAUncatTrxs: url + 'FU_Uncat_Trx',
    getClientAnalytics: url + 'FU_Uncat_Trx/dashboardClientAnalytics',
    getDateTrxAnalytics: url + 'FU_Uncat_Trx/dashboardTrxAnalytics',
    getCBUncatTrxs: url + 'FU_Uncat_Trx/Client',
    getClientsDropdownList: url + 'FU_AS_ClientSettings/currOrg',
    getCBCustomers: url + 'FUClient_Settings/GetCustomersOfCBQBO/',
    getCBVendors: url + 'FUClient_Settings/GetVendorsOfCBQBO/',
    getCBAccounts: url + 'V_Organization/CBIncomeExpenseAccounts/',
    getCBClass: url + 'V_Organization/CBQBOClass/',
    getCBLocations: url + 'V_Organization/CBQBODepartment/',
    hideTrx: url + 'FU_Uncat_Trx/Hide/',
    approveTrx: url + 'FU_Uncat_Trx/Approve',
    commentsByTrx: url + 'FU_Uncat_Trx/CommentsByTrx/',
    trxComments: url + 'FU_Uncat_Trx/Comments',
    deleteComment: url + 'FU_Uncat_Trx/CommentDelete/',
    removeTrx: url + 'FU_Uncat_Trx/uncattrx/',
    updateFiscalYear: url + 'FUClient_Settings/CBFiscalYear',
    filesByTrx: url + 'FU_Uncat_Trx/Files/',
    notifyClient: url + 'VCPortal/Fix-uncat/NotifyNow/',
    splitTrx: url + 'FU_Uncat_Trx/splitLine',
    fuTags: url + 'FUTags/CurrOrgCategories',
    verifyClientwithSecretecode: url + 'FU_AS_ClientSettings/verifyClientBySecretCode',
    getUncatTrxFromQBOCommand: url + 'FU_AS_ClientSettings/getUncatTrxFromQBO',
}

// audits
export const Audits = {
    auTemplateBankList: url + 'AU_Audit_Template_Bank/BankList',
    auTemplateBank: url + 'AU_Audit_Template_Bank',
    auTemplateBanksteps: url + 'AU_Audit_Template_Bank/Steps',
    auTemplatesCurrOrgList: url + 'AU_Audit_Templates/CurrOrgList',
    auAuditTemplates: url + 'AU_Audit_Templates',
    auTemplatesCurrOrg: url + 'AU_Audit_Templates/CurrOrg',
    auSpAuditJobsCurrOrgJobs: url + 'AU_SP_Audit_Jobs/CurrOrgJobs',
    auSpAuditJobs: url + 'AU_SP_Audit_Jobs',
    auSpAuditCopyJob: url + 'AU_SP_Audit_Jobs/CopyJob',
    auSpAuditJobsCurrOrgJobsDropdown: url + 'AU_SP_Audit_Jobs/CurrOrgJobsDropdown',
    auSpMilestonesByJob: url + 'AU_SP_Milestones/ByJob',
    auSpMilestones: url + 'AU_SP_Milestones',
    auspAuditTasksAllJobTasks: url + 'AU_SP_Audit_Tasks/AllJobTasks',
    auspAuditTaskMyJobTAsks: url + 'AU_SP_Audit_Tasks/MyJobTasks',
    auSpAuditJobsTeamByJobCustomer: url + 'AU_SP_Audit_Jobs/TeamByJobCustomer',
    auspAuditTasks: url + 'AU_SP_Audit_Tasks',
    auSpAuditCurrOrgApproverList: url + 'AU_SP_Audit_Tasks/CurrOrgApproversList',
    auSpAuditTasksCurrUserTaskApprovals: url + 'AU_SP_Audit_Tasks/CurrUserTaskApprovals',
    auSpAuditTasksUpdateApproval: url + 'AU_SP_Audit_Tasks/UpdateApproval',
    apSpAuditTaskApprovalByTask: url + 'AU_SP_Audit_Tasks/TaskApprovalByTask',
    auSpCommentByJob: url + 'AU_SP_Comments/ByJob',
    auSpComments: url + 'AU_SP_Comments',
    auSpCommentsByJobTask: url + 'AU_SP_Comments/ByJobTask',
    acSpTimerByAuditTask: url + 'AC_SP_Timer/ByAuditTask',
    auSpAuditNonConformanceByJobOrTask: url + 'AU_SP_Audit_Non_Conformance/ByJobOrTask',
    auspAuditRootCauseByJobOrTask: url + 'AU_SP_Audit_Root_Cause/ByJobOrTask',
    auSpAuditCAPAByJobOrTask: url + 'AU_SP_Audit_CAPA/ByJobOrTask',
    auSpAuditNonConformance: url + 'AU_SP_Audit_Non_Conformance',
    auSpAuditNonConforCurrOrg: url + 'AU_SP_Audit_Non_Conformance/CurrOrg',
    auMySpAuditNonConfor: url + 'AU_SP_Audit_Non_Conformance/CurrOrgNConformances',
    auSpAuditNCAddMap: url + 'AU_SP_Audit_Non_Conformance/AddMap',
    auSpAuditrootCause: url + 'AU_SP_Audit_Root_Cause',
    auSpAuditRootCauseCurrOrg: url + 'AU_SP_Audit_Root_Cause/CurrOrg',
    auMySpAuditRootCause: url + 'AU_SP_Audit_Root_Cause/CurrOrgRootCause',
    auSpAuditCAPACurrOrg: url + 'AU_SP_Audit_CAPA/CurrOrg',
    auMySpAuditCAPA: url + 'AU_SP_Audit_CAPA/CurrOrgCAPA',
    auSpAuditCAPA: url + 'AU_SP_Audit_CAPA',
    auAuditTemplateSteps: url + 'AU_Audit_Templates/Steps'
}

// LiecenseManagement

export const LiecenseManagement = {
    lmSpJobsCurrOrgJobsDropdown: url + 'LM_SP_Jobs​/CurrOrgJobsDropdown',
    lmMileStonesByJob: url + 'LM_Milestones/ByJob',
    lmMilestones: url + 'LM_Milestones',
    lmJobTaskCurrUserTaskApprovals: url + 'LM_Job_Tasks/CurrUserTaskApprovals',
    lmJobTaskTaskApprovalByTask: url + 'LM_Job_Tasks/TaskApprovalByTask',
    lmJobTasks: url + 'LM_Job_Tasks',
    lmJobTasksByJob: url + 'LM_Job_Tasks/ByJob',
    lmTaskISsuesByJobTask: url + 'LM_Task_Issues/ByJobTask',
    lmTaskIssue: url + 'LM_Task_Issues',
    lmJobTaskUpdateLMApprovals: url + 'LM_Job_Tasks/UpdateLM_Approvals',
    lmServiceBank: url + 'LM_Services_Bank',
    licensesInfoUs: url + 'LM_License_Info_US',
    licensesInfoSearch: url + 'LM_License_Info_US/Search',
    licensesInfoSearchLines: url + 'LM_License_Info_US/Step',
    licensesInfoLines: url + 'LM_License_Info_US/Steps',
    lmServiceBankSteps: url + 'LM_Services_Bank/Steps',
    lmJobCopyJob: url + 'LM_SP_Jobs/CopyJob',
    lmServiceBankBankList: url + 'LM_Services_Bank/BankList',
    lmTemplateCurrOrg: url + 'LM_Templates/CurrOrg',
    lmTemplate: url + 'LM_Templates',
    lmTemplateSteps: url + 'LM_Templates/Steps',
    lmJobTasksCurrOrgApproversList: url + 'LM_Job_Tasks/CurrOrgApproversList',
    lmSpJobsCurrOrgJobs: url + 'LM_SP_Jobs/CurrOrgJobs',
    lmTemplateCurrOrgList: url + 'LM_Templates​/CurrOrgList',
    lmSpJobs: url + 'LM_SP_Jobs',
    lmJobTask: url + 'LM_Job_Tasks',
    lmJobTaskdropdown: url + 'LM_Job_Tasks/MyJobTasksDropdown',
    lmSPJObsTeamByJobCustomer: url + 'LM_SP_Jobs/TeamByJobCustomer',
    lmjobTaskAllJobTasks: url + 'LM_Job_Tasks​/AllJobTasks',
    lmJobTaskMyJobTasks: url + 'LM_Job_Tasks​/MyJobTasks',
    lmComments: url + 'LM_Comments',
    lmCommentsByJob: url + 'LM_Comments/ByJob',
    lmCommentsByJobTask: url + 'LM_Comments/ByJobTask',
}


export const ChatManagement = {
    myContacts: url + 'ChatRoom/MyContacts',
    myTeam: url + 'ChatRoom/Team',
    myAccountants: url + 'ChatRoom/Accountants',
    myChatRoom: url + 'ChatRoom/MyChatRoom',
    Chat: url + 'ChatRoom/Chat',
    postChat: url + 'ChatRoom',
    postChatRoom: url + 'ChatRoom/PostChat',
    ChatRoom: url + 'ChatRoom/ChatRoom',

}
export const LMS = {
    msServicesCurrOrg: url + 'MentorServices/CurrOrg',
    myStripeProductsList: url + 'Stripe/GetStripeProductsList',
    msServicesByMentor: url + 'Stripe/GetStripeProductsListByMentor',
    msServicesByOrg: url + 'Stripe/GetStripeProductsListByOrg',
    UnassignServiceFromRoom: url + 'MentorServices/UnassignServiceFromRoom/',
    msServicesList: url + 'MentorServices/CurrOrgList',
    msServices: url + 'MentorServices',
    postGuidelines: url + 'KS_Bot_Guidelines',
    deleteGuidelines: url + 'KS_Bot_Guidelines/line',
    postLiveStream: url + 'KS_MentorLivestream',
    getLiveStreams: url + 'KS_MentorLivestream/MyLivestreams',
    getLiveStreamsList: url + 'KS_MentorLivestream/MyLivestreamsList',
    getRoomsList: url + 'KS_AI_Rooms/RoomsSearch',
    getRoomsListType: url + 'KS_AI_Rooms/MyRooms',
    getCommunityRooms: url + 'KS_AI_Rooms/CommunityRoomsSearch',
    getSyllabus: url + 'KS_AI_Rooms/RoomSyllabus',
    getUsersData: url + 'KS_AI_Rooms/usersSearch',
    getMentorsDirectory: url + 'V_User_Profile/MentorsDirectory',
    AiBot: url + 'KS_AI_Bot',
    getBotGroups: url + 'KS_AI_BotGroups/TutorGroups',
    aiBotTopicPublicPrivate: url + 'KS_AI_Bot/makeTopicPublicPrivate',
    postassignedBotGroups: url + 'KS_AI_BotGroups/assignGroup',
    getassignedTutors: url + 'KS_AI_BotGroups/CurrOrgTutorsGroupMapList',
    botGroupByData: url + 'KS_AI_BotGroups/ById',
    getTutorsList: url + 'KS_AI_BotGroups/MyTutorGroupsList',
    postBotGroups: url + 'KS_AI_BotGroups/TutorGroups',
    updateTutorgroup: url + 'KS_AI_BotGroups/TutorGroup',
    deleteTutorgroup: url + 'KS_AI_BotGroups/tutorGroup',
    getBotGroupLists: url + 'KS_AI_BotGroups/MyTutorGroupsList',
    getGroupsByTutor: url + 'KS_AI_BotGroups/TutorGroupsByTutor',
    ActiveInactiveAiBot: url + 'KS_AI_Bot/Bot',
    aiBotFileRemove: url + 'KS_AI_Bot/DeleteBotFile',
    aiBotGuidelineRemove: url + 'KS_AI_Bot/DeleteBotGuideline',
    aiBotModelRemove: url + 'KS_AI_Bot/DeleteBotModel',
    aiBotChatGpt: url + 'KS_AI_Bot/BotChatGPT',
    aiBotaddfiles: url + 'KS_AI_Bot/AddFiles',
    aiBotgetfiles: url + 'KS_AI_Bot/TutorFiles',
    postChat: url + 'KS_AI_Rooms/PostChat',
    updatetChat: url + 'KS_AI_Rooms/UpdateChat',
    roomInvite: url + 'KS_AI_Rooms/RoomInvite',
    aiRoomChatGpt: url + 'KS_AI_Rooms/RoomChatGPT',
    MyRoomInviteRequests: url + 'KS_AI_Rooms/MyRoomInviteRequests',
    MyRoomInvitationsReceived: url + 'KS_AI_Rooms/RoomsInvitationsReceived',
    MyRoomInvitationsSent: url + 'KS_AI_Rooms/RoomsInvitationsSent',
    joinRoom: url + 'KS_AI_Rooms/JoinInRoom',
    roomAcceptIgnore: url + 'KS_AI_Rooms/RoomAcceptOrIgnore',
    getChat: url + 'KS_AI_Rooms/Chat',
    getBotbytype: url + 'KS_AI_Bot/ByType',
    getBotSearch: url + 'KS_AI_Bot/Search',
    getBotSearchAnonymous: url + 'KS_AI_Bot/SearchAnonymous',
    manageMyRooms: url + 'KS_AI_Rooms/MyRoomsManageByRoom',
    myInvitationsFromRooms: url + 'KS_AI_Rooms/MyInvitationsFromRooms',
    assignRoomId: url + 'KS_AI_Rooms/AssignBots',
    botLikes: url + 'KS_AI_Bot/Like',
    botDisLikes: url + 'KS_AI_Bot/Dislike',
    botComment: url + 'KS_AI_Bot/Comment',
    botRating: url + 'KS_AI_Bot/Rating',
    botReviewDetails: url + 'KS_AI_Bot/ReviewDetails',
    botCommentsgetById: url + 'KS_AI_Bot/Comments',
    aiBotTopicsHistory: url + 'KS_AI_Bot/TopicsHistory',
    aiRoomTopicsHistory: url + 'KS_AI_Rooms/TopicsHistory',
    deleteaiBotTopicsHistory: url + 'KS_AI_Bot/topic',
    deleteaiBotIndividualMessage: url + 'KS_AI_Bot/topicMessage',
    aiBotTopicsHistoryMessages: url + 'KS_AI_Bot/TopicsHistoryMessages',
    joinInRoom: url + 'KS_AI_Rooms/JoinInRoom',
    postQuestion: url + 'KS_AI_RoomPosts/CreatePost',
    getRoomQuestions: url + 'KS_AI_RoomPosts/RoomPosts',
    postReplyquestions: url + 'KS_AI_RoomPosts/CreateReplyPost',
    getRoomHistoryQuestions: url + 'KS_AI_RoomPosts/RoomPostsByHeader',
    getRoomAnswersByQuestion: url + 'KS_AI_RoomPosts/Answers',
    BotSubject: url + 'KS_Ai_BotNotes/Subject',
    BotTopics: url + 'KS_Ai_BotNotes/Topic',
    BotNotesById: url + 'KS_Ai_BotNotes',
    BotNotesByRoom: url + 'KS_Ai_BotNotes/ByRoom',
    BotNotesByNotes: url + 'KS_Ai_BotNotes/Notes',
    BotNotesReviewDetails: url + 'KS_Ai_BotNotes/ReviewDetails',
    RoomReviewDetails: url + 'KS_AI_Rooms/ReviewDetails',
    BotNotesByTopic: url + 'KS_Ai_BotNotes/Topic',
    postBotLink: url + 'KS_AI_Bot/Link',
    getBotLink: url + 'KS_AI_Bot/Links',
    assignTutorsToStaff: url + 'KS_AI_BotAdminsAssign/AssignTutors',
    getAssignedTutorsToStaff: url + 'KS_AI_BotAdminsAssign/AssignedTutorsByUser',
    deleteAssignedTutorsToStaff: url + 'KS_AI_BotAdminsAssign/DeleteAssigned',
    assignRoomsToStaff: url + 'KS_AI_RoomAdminsAssign/AssignRooms',
    getAssignedRoomsToStaff: url + 'KS_AI_RoomAdminsAssign/AssignedRoomsByUser',
    deleteAssignedRoomsToStaff: url + 'KS_AI_RoomAdminsAssign/DeleteAssigned',
    activeroommember: url + 'KS_AI_Rooms/EnableRoomMember',
    postById: url + 'KS_AI_RoomPosts/PostById',
    updatePost: url + 'KS_AI_RoomPosts/EditPost',
    assignRoomsToMenteeGroups: url + 'KS_AI_RoomMenteesAssign/AssignRooms',
    getAssignedRoomsToMenteeGroups: url + 'KS_AI_RoomMenteesAssign/AssignedRoomsByGroup',
    deleteAssignedRoomsToMenteeGroups: url + 'KS_AI_RoomMenteesAssign/DeleteAssigned',
    postbotShare: url + 'KS_AI_Bot/BotShare',
    GetPublicRoomsByBot: url + 'KS_AI_Rooms/PublicRoomsByBot',
    botMySharedUsersToBot: url + 'KS_AI_Bot/MySharedUsersToBot',
    resourcePost: url + 'KS_AI_Rooms/AiFilesFeedAi',
    resourceGet: url + 'KS_AI_Rooms/AiFilesFeedAiByRoom',
    makeRoomAdmin: url + 'KS_AI_Rooms/MakeAdmin',
    getGuidelinesBankList: url + 'KS_Bot_Guidelines/BankList',
    resourceEdit: url + 'KS_AI_Rooms/AiFilesFeedAi',
    botGuidelines: url + 'KS_Bot_Guidelines/VGuideline',
    resourceDelete: url + 'KS_AI_Rooms/AiFilesFeedAi',
    updateRoomTerms: url + 'KS_AI_Rooms/RoomTerms',
    unAssignBots: url + 'KS_AI_Rooms/UnAssignBot',
    RemoveFromRoom: url + 'KS_AI_Rooms/RemoveFromRoom',
    activeorinactiveroom: url + 'KS_AI_Rooms/EnableOrDisableRoom',
    deleteRoom: url + 'KS_AI_Rooms/DeleteRoom',
    topicsRoomhistory: url + 'KS_AI_Bot/TopicsHistoryByRoom',
    getBotsInRoom: url + 'KS_AI_Rooms/BotsByRoom',
    IndividualChatPost: url + 'KS_AI_Rooms/PostIndividualChat',
    IndividualChatUpdate: url + 'KS_AI_Rooms/UpdateIndividualChat',
    getIndividualChat: url + 'KS_AI_Rooms/IndividualChat',
    PostIndividualChat: url + 'KS_AI_Rooms/KS_AI_Rooms_PostIndividualChat',
    following: url + 'KS_AI_RoomPosts/FollowingUsers',
    followers: url + 'KS_AI_RoomPosts/Followers',
    followMember: url + 'KS_AI_RoomPosts/FollowMember',
    unFollowMember: url + 'KS_AI_RoomPosts/UnfollowMember',
    likePost: url + 'KS_AI_RoomPosts/LikePost',
    disLikePost: url + 'KS_AI_RoomPosts/DislikePost',
    favoritePost: url + 'KS_AI_RoomPosts/Favorite',
    postFavoriteBots: url + 'KS_AI_RoomPosts/Favorite',
    removeFavouritespost: url + 'KS_AI_RoomPosts/RemoveFromPostFavorite',
    getReadingLists: url + 'KS_AI_RoomPosts/ReadingLists',
    getAnnouncements: url + 'KS_AI_RoomPosts/Announcements',
    clearReadingList: url + 'KS_AI_RoomPosts/clearReadingList',
    clearAnnouncement: url + 'KS_AI_RoomPosts/clearAnnouncement',
    removeFavoriteBots: url + 'KS_AI_RoomPosts/RemoveFromBookFavorite',
    FavoriteBotNotes: url + 'KS_AI_RoomPosts/MyFavoriteRoomBooks',
    getComment: url + 'KS_AI_RoomPosts/CommentsByPost',
    commentPost: url + 'KS_AI_RoomPosts/CreateComment',
    deleteComment: url + 'KS_AI_RoomPosts/DeleteComment',
    updateComment: url + 'KS_AI_RoomPosts/UpdateComment',
    FavoriteRoomQuestions: url + 'KS_AI_RoomPosts/MyFavoriteRoomQuestions',
    FavoriteRoomNotes: url + 'KS_AI_RoomPosts/MyFavoriteRoomNotes',
    DeleteRoomPost: url + 'KS_AI_RoomPosts/DeleteRoomPost',
    RoomQuestionLock: url + 'KS_AI_RoomPosts/LockRoomPost',
    RoomPostInAppropriate: url + 'KS_AI_RoomPosts/InAppropriateRoomPost',
    RoomPosteditAnswer: url + 'KS_AI_RoomPosts/EditAnswer',
    RoomPostedCurrectAnswer: url + 'KS_AI_RoomPosts/MarkAsCurrectAnswer',
    RoomPostedEditQuestion: url + 'KS_AI_RoomPosts/EditQuestion',
    RoomPostedEditNotes: url + 'KS_AI_RoomPosts/EditNotes',
    RoomPostedDeleteAnswer: url + 'KS_AI_RoomPosts/DeleteAnswer',
    RoomPostedReadPost: url + 'KS_AI_RoomPosts/ReadPost',
    GetTeamAvtivity: url + 'KS_Reports/Staff/TeamActivityByDate',
    RoomPostedVoteForAnswer: url + 'KS_AI_RoomPosts/VoteForAnswer',
    RoomPostedRemoveVoteForAnswer: url + 'KS_AI_RoomPosts/RemoveVoteForAnswer',
    getRoomPostedStatistics: url + 'KS_AI_RoomPosts/RoomStatistics',
    getRoomPostsViewedMembers: url + 'KS_AI_RoomPosts/PostsViewedMembers',
    getRoomPostsAnswersVotedMembers: url + 'KS_AI_RoomPosts/AnswersVotedMembers',
    getRoomStatistics: url + 'KS_AI_Rooms/RoomStatistics',
    getRoomMembersStatistics: url + 'KS_AI_Rooms/RoomMembersStatistics',
    getResourceFilesUsage: url + 'SMBChatTopic/ResourceFilesUsage ',
    getAppMembershipUsageHistory: url + 'V_Organization/AdminsAppUsageHistory',
    getAssignedTutorToGroup: url + 'KS_AI_RoomMenteesAssign/AddedFavTutorsByGroup',
    deleteAssignedTutorsToGroup: url + 'KS_User_Favorites/UnfavoriteById',
    assignTutorsToGroup: url + 'KS_AI_RoomMenteesAssign/AddTutorsToMenteeFav',
    getMyAnnouncementsFeed: url + 'KS_Feed/MyAnnouncements',
    getMyReadingListFeed: url + 'KS_Feed/MyReadingLists',
    getMyFeed: url + 'KS_Feed/MyFeed',
    getOrgReports: url + 'KS_Reports/OrgTutors',
    getOrgRooms: url + 'KS_Reports/OrgRooms',
    getOrgReportsById: url + 'KS_Reports/AssignedTutorsToStaff',
    getOrgRoomsById: url + 'KS_Reports/AssignedRoomsToStaff',
    getOrgTutorsList: url + 'KS_AI_Bot/OrgTutorsList',
    getCountries: url + 'V_CC_State/CountriesDropdown',
    getWebRoomPosts: url + 'KS_AI_RoomPosts/WebRoomPosts',
    getWebRoomHistoryQuestions: url + 'KS_AI_RoomPosts/WebRoomPostsByHeader',
    getWebRoomAnswersByQuestion: url + 'KS_AI_RoomPosts/WebAnswers',
    aiBotTopicsHistoryMessagesWeb: url + 'KS_AI_Bot/TopicsHistoryMessagesWeb',
    aiBotTopicsHistoryWeb: url + 'KS_AI_Bot/TopicsHistoryWeb',
    getShareTutorDetails: url + 'KS_AI_Bot/share',
    AIBotFeedToAI: url + 'KS_Ai_BotNotes/FeedToAi',
}
